import {
  Box,
  Button,
  Card,
  Grid,
  TextField,
  Typography,
  selectClasses,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import { Colors } from "../../../Constant/Color";
import { useDispatch, useSelector } from "react-redux";
import { IoMdClose } from "react-icons/io";
import {
  edit,
  selectInvoicedCustomer,
  updateAllInvoices,
  updateCart,
  updateCustomers,
  updateDayReturnInvoiceEmp,
  updateInvoice,
  updateSuppliers,
  updateTodayEmployeeClaimInvoices,
  updateAllReturnInvoices,
  updateTodayEmployeeWarrantyInvoices,
  updateVat,
  viewSelectedInvoice,
  updateRevenue,
  updateTrashProducts,
  updateExhangeProducts,
  selectCustomers,
  updateProducts,
  updatetodayEmployeeExchangeInvoice,
  updateAllExchangeInvoice,
  updateAllReturnProducts,
  updateAllReturnProductsDuplicate,
} from "../../../Redux/LoginReduces";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import CustomPOSModal from "../../../Components/PosModal";
import { startShift } from "../../../Redux/LoginReduces";

import OnlineTransactionModal from "../../../Components/onlineTransactionModal";
import CustomModal2 from "../../../Components/CustomModal2";
import ChequeModal from "../../../Components/CheckModal";
import BasicSelect from "../../../Components/Dropdown";
import CustomModal from "../../../Components/modal";
import CustomButton from "../../../Components/Button";
import { Base_Uri, Image_Uri } from "../../../Constant/BaseUri";
import { ArrowBackIosNewOutlined } from "@mui/icons-material";
import axios from "axios";
import Checkbox from "../../../Components/checkbox";
import InvoiceModal from "../../../Components/viewInvoiceDetailModal";
import printComponent from "../../../Components/printComponent";
import PrintComponent from "../../../Components/printComponent";
import html2canvas from "html2canvas";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import jsPDF from "jspdf";
import DownloadIcon from "@mui/icons-material/Download";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import PaymentMethodModal from "../../../Components/paymentMethodModal";
import Damages from "../../Damages/damages";
import OptionModal from "../../../Components/optionModal";
import CreditWarningModal from "../../../Components/creditLimitWarningModal";
import CartProductEditModal from "../../../Components/CartProductEditModal";
import useBarcodeQueue from "./UseBarcodeQueue.jsx"

import {
  Document,
  Page,
  Text,
  View,
  PDFViewer,
  PDFDownloadLink,
  Image,
  Font,
} from "@react-pdf/renderer";
//import MyFontRegular from "/fonts/Poppins-Medium.ttf";
//import MyFontBold from "/fonts/Poppins-Medium.ttf";
import useScanDetection from "use-scan-detection";
import { Alert, message, Modal, notification, Popconfirm } from "antd";
import debounce from "lodash.debounce";
import { CUSTOMERINFO, IS_EDIT_OPEN, SELECTED_CUSTOMER, SELECTED_INVOICES } from "../../../Context";
import InvoiceSelectorModal from "./SearchInvoiceWithFIlter";
// import { randomUUID } from "crypto";

const MainPage = ({
  customerRef,
  barcodeRead,
  setBarcodeRead,
  setReturnModal,
  isEdit,setIsEdit
}) => {
  Font.register({
          family: 'MyFont',
          fonts: [
              { src: "/fonts/Poppins-Bold.ttf", fontWeight: 'bold' },
              { src: "/fonts/Poppins-Medium.ttf", fontWeight: 'normal' },
          ]
      });

  const dispatch = useDispatch();

  const promiseResolveRef = useRef();
  const customerInputRef = useRef(null);
  const productInputRef = useRef(null);

  const componentRef = useRef();
  const navigate = useNavigate();
  const {extraCustomerInfo,setExtraCustomerInfo} = useContext(CUSTOMERINFO)

  const startShifts = useSelector((state) => state.loginReducer.startShift);
  const [refHover, setRefHover] = useState(false);
  const startShiftsTime = useSelector(
    (state) => state.loginReducer.startShiftTime
  );
  const userData = useSelector((state) => state.loginReducer.updatedState);
  const exchangeProducts = useSelector(
    (state) => state.loginReducer?.exchangeProducts
  );

  const allReturnProducts = useSelector(
    (state) => state.loginReducer?.allReturnProductsDuplicate
  );

  const [productStatus, setProductStatus] = useState([
    "Sale",
    "Return",
    "Damage",
    "Bin",
  ]);

  const customers = useSelector((state) => state.loginReducer.customers);
  const products = useSelector((state) => state.loginReducer.products);
  const cart = useSelector((state) => state.loginReducer.cart);
  const todayInvoices = useSelector((state) => state.loginReducer.invoices);
  const customerType = useSelector((state) => state.loginReducer.customerType);
    const JobDetails = useSelector((state) => state.loginReducer.jobDetails);
// console.log(JobDetails,"JobDetails")

  const [editCartProductData, setEditCartProductData] = useState("");
  const {isEditOpen,setIsEditOpen} = useContext(IS_EDIT_OPEN)
  const playBeep = () => {
    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(1000, audioCtx.currentTime); // Frequency in Hz
    oscillator.start();
    oscillator.stop(audioCtx.currentTime + 0.2); // Beep duration (0.2s)
  };

//   async function checkPrinters() {
//   const result =
//     await window.printer.getPrinters();

//   console.log("PRINTERS:", result);
// }

// checkPrinters()

 const escapeHtml = (value) => {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

const formatMoney = (value) => {
  const amount = Number(value || 0);

  return `£${amount.toFixed(2)}`;
};

const formatReceiptDate = (dateValue) => {
  if (!dateValue) return "-";

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const getProductPrice = (
  product,
  customer
) => {
  const priceLevel =
    customer?.priceLevel?.[0]?.id;

  let price = Number(
    product?.retail_price || 0
  );

  if (priceLevel === 1) {
    price = Number(
      product?.trade_price || 0
    );
  } else if (priceLevel === 2) {
    price = Number(
      product?.warehouse_price || 0
    );
  }

  /*
   * If discountPrice exists and is valid,
   * use it.
   */
  if (
    product?.discountPrice !== undefined &&
    product?.discountPrice !== null &&
    product?.discountPrice !== ""
  ) {
    const discountPrice = Number(
      product.discountPrice
    );

    if (
      Number.isFinite(discountPrice) &&
      discountPrice >= 0
    ) {
      price = discountPrice;
    }
  }

  return price;
};

const handleOpenTill = async () => {
  try {
    const result = await window.electronAPI.openTill();
    console.log("Open till result:", result);

    if (!result?.success) {
      console.error("Till failed to open:", result?.error);
    }
  } catch (error) {
    console.error("Open till error:", error);
  }
};

const handlePrint = async () => {
  console.log(
    "PRINT BUTTON CLICKED"
  );

  try {
    if (
      !window.electronAPI
        ?.printReceipt
    ) {
      console.error(
        "Electron print API not available"
      );

      return;
    }

    /*
     * CHANGE THESE TWO VARIABLES ONLY
     * if your actual state variable names
     * are different.
     */

    const invoice =
      printInvoiceData;

    const company =
      vat;

    if (!invoice) {
      console.error(
        "Invoice data missing"
      );

      return;
    }

    /* ================================
       COMPANY
    ================================= */

    const companyDisplayName =
      company?.nickName?.trim() ||
      company?.companyName?.trim() ||
      "Company";

    const companyLegalName =
      company?.companyName?.trim();

    const showLegalCompanyName =
      company?.nickName?.trim() &&
      companyLegalName &&
      companyLegalName !==
        companyDisplayName;

    const addressParts = [
      company?.companyAddress,
      company?.city,
      company?.postCode,
    ]
      .filter(
        (value) =>
          value &&
          String(value).trim()
      )
      .map((value) =>
        String(value).trim()
      );

    const companyAddress =
      addressParts.join(", ");

    /* ================================
       CUSTOMER
    ================================= */

    const customer =
      invoice?.customerDetails?.[0] ||
      {};

    const customerName =
      customer?.businessName ||
      customer?.customerName ||
      invoice?.customerName ||
      "Walk-in Customer";

    /* ================================
       PRODUCTS
    ================================= */

    const products =
      invoice?.productDetails || [];

    const productRows =
      products
        .map((product) => {
          const qty = Number(
            product?.saleQty || 1
          );

          const unitPrice =
            getProductPrice(
              product,
              customer
            );

          const lineTotal =
            unitPrice * qty;

          const productName =
          product?.productName ||
            product?.product_name ||
            "Product";

          const sku =
            product?.sku ||
            product?.barcode ||
            "";

          return `
            <div class="product">
              <div class="product-name">
                ${escapeHtml(
                  productName
                )}
              </div>

              ${
                sku
                  ? `
                    <div class="product-code">
                      ${escapeHtml(sku)}
                    </div>
                  `
                  : ""
              }

              <div class="product-calculation">
                <span>
                  ${qty} × ${formatMoney(
                    unitPrice
                  )}
                </span>

                <strong>
                  ${formatMoney(
                    lineTotal
                  )}
                </strong>
              </div>
            </div>
          `;
        })
        .join("");

    /* ================================
       PAYMENT
    ================================= */

    const paymentMethods = Array.isArray(
      invoice?.paymentMethod
    )
      ? invoice.paymentMethod
      : [];

    const paymentRows = [];

    if (Number(invoice?.cash) > 0) {
      paymentRows.push({
        name: "Cash",
        amount: invoice.cash,
      });
    }

    if (Number(invoice?.card) > 0) {
      paymentRows.push({
        name: "Card",
        amount: invoice.card,
      });
    }

    if (Number(invoice?.online) > 0) {
      paymentRows.push({
        name: "Online",
        amount: invoice.online,
      });
    }

    if (Number(invoice?.credit) > 0) {
      paymentRows.push({
        name: "Credit",
        amount: invoice.credit,
      });
    }

    if (Number(invoice?.cheque) > 0) {
      paymentRows.push({
        name: "Cheque",
        amount: invoice.cheque,
      });
    }

    /*
     * Fallback if individual amounts
     * are not available.
     */
    if (
      paymentRows.length === 0 &&
      paymentMethods.length > 0
    ) {
      paymentRows.push({
        name: paymentMethods
          .map((method) => {
            const text =
              String(method || "");

            return (
              text
                .charAt(0)
                .toUpperCase() +
              text.slice(1)
            );
          })
          .join(" / "),
        amount: invoice?.total,
      });
    }

    const paymentHtml =
      paymentRows
        .map(
          (payment) => `
            <div class="row">
              <span>
                ${escapeHtml(
                  payment.name
                )}
              </span>

              <strong>
                ${formatMoney(
                  payment.amount
                )}
              </strong>
            </div>
          `
        )
        .join("");

    /* ================================
       EMPLOYEE / CASHIER
    ================================= */

    const employee =
      invoice?.employeeDetails?.[0];

    const cashierName =
      employee?.fullName ||
      invoice?.employeeName ||
      "-";

    /* ================================
       RECEIPT NUMBER
    ================================= */

    const invoiceNumber =
      invoice?.invoiceNumber &&
      invoice.invoiceNumber !== "NaN"
        ? invoice.invoiceNumber
        : invoice?._id
          ? String(invoice._id).slice(-8)
          : "-";

    /* ================================
       RECEIPT HTML
    ================================= */

    const html = `
      <div class="receipt">

        <!-- COMPANY HEADER -->

        <div class="header">

          <div class="company-name">
            ${escapeHtml(
              companyDisplayName
            )}
          </div>

          ${
            showLegalCompanyName
              ? `
                <div class="legal-name">
                  ${escapeHtml(
                    companyLegalName
                  )}
                </div>
              `
              : ""
          }

          ${
            companyAddress
              ? `
                <div class="company-detail">
                  ${escapeHtml(
                    companyAddress
                  )}
                </div>
              `
              : ""
          }

          ${
            company?.mobileNumber
              ? `
                <div class="company-detail">
                  Tel:
                  ${escapeHtml(
                    company.mobileNumber
                  )}
                </div>
              `
              : ""
          }

          ${
            company?.companyEmail
              ? `
                <div class="company-detail">
                  ${escapeHtml(
                    company.companyEmail
                  )}
                </div>
              `
              : ""
          }

          ${
            company?.vatNumber
              ? `
                <div class="company-detail">
                  VAT No:
                  ${escapeHtml(
                    company.vatNumber
                  )}
                </div>
              `
              : ""
          }

          ${
            company?.companyNumber
              ? `
                <div class="company-detail">
                  Company No:
                  ${escapeHtml(
                    company.companyNumber
                  )}
                </div>
              `
              : ""
          }

        </div>


        <div class="divider"></div>


        <!-- RECEIPT INFO -->

        <div class="receipt-title">
          SALES RECEIPT
        </div>

        <div class="info-section">

          <div class="row">
            <span>Receipt #</span>
            <strong>
              ${escapeHtml(
                invoiceNumber
              )}
            </strong>
          </div>

          <div class="row">
            <span>Date</span>
            <strong>
              ${escapeHtml(
                formatReceiptDate(
                  invoice?.saleDate
                )
              )}
            </strong>
          </div>

          <div class="row">
            <span>Cashier</span>
            <strong>
              ${escapeHtml(
                cashierName
              )}
            </strong>
          </div>

        </div>


        <div class="divider dashed"></div>


        <!-- CUSTOMER -->

        <div class="section-title">
          CUSTOMER
        </div>

        <div class="customer-name">
          ${escapeHtml(
            customerName
          )}
        </div>

        ${
          customer?.accountNo
            ? `
              <div class="small-row">
                Account:
                ${escapeHtml(
                  customer.accountNo
                )}
              </div>
            `
            : ""
        }

        ${
          customer?.address ||
          customer?.city ||
          customer?.postalCode
            ? `
              <div class="small-row">
                ${escapeHtml(
                  [
                    customer?.address,
                    customer?.city,
                    customer?.postalCode,
                  ]
                    .filter(Boolean)
                    .join(", ")
                )}
              </div>
            `
            : ""
        }


        <div class="divider dashed"></div>


        <!-- PRODUCTS -->

        <div class="product-heading">
          <span>ITEM</span>
          <span>AMOUNT</span>
        </div>

        ${productRows}


        <div class="divider"></div>


        <!-- TOTALS -->

        <div class="totals">

          <div class="row">
            <span>Items</span>
            <strong>
              ${Number(
                invoice?.totalQty ||
                  products.length ||
                  0
              )}
            </strong>
          </div>

          <div class="row">
            <span>Subtotal</span>
            <strong>
              ${formatMoney(
                invoice?.subtotal
              )}
            </strong>
          </div>

          ${
            Number(
              invoice?.discount
            ) > 0
              ? `
                <div class="row">
                  <span>Discount</span>

                  <strong>
                    -${formatMoney(
                      invoice.discount
                    )}
                  </strong>
                </div>
              `
              : ""
          }

          ${
            Number(
              invoice?.additionalAmount
            ) > 0
              ? `
                <div class="row">
                  <span>
                    Additional
                  </span>

                  <strong>
                    ${formatMoney(
                      invoice.additionalAmount
                    )}
                  </strong>
                </div>
              `
              : ""
          }

          ${
            Number(
              invoice?.vatAmount
            ) > 0
              ? `
                <div class="row">
                  <span>
                    VAT ${
                      company?.vatRate
                        ? `(${company.vatRate}%)`
                        : ""
                    }
                  </span>

                  <strong>
                    ${formatMoney(
                      invoice.vatAmount
                    )}
                  </strong>
                </div>
              `
              : ""
          }

          <div class="grand-total">
            <span>TOTAL</span>

            <span>
              ${formatMoney(
                invoice?.total
              )}
            </span>
          </div>

        </div>


        <!-- PAYMENT -->

        ${
          paymentHtml
            ? `
              <div class="divider dashed"></div>

              <div class="section-title">
                PAYMENT
              </div>

              <div class="payment-section">
                ${paymentHtml}
              </div>
            `
            : ""
        }


        <div class="divider"></div>


        <!-- FOOTER -->

        <div class="footer">

          <div class="thank-you">
            Thank you for your purchase!
          </div>

          <div class="footer-text">
            We appreciate your business.
          </div>

          ${
            company?.mobileNumber
              ? `
                <div class="footer-text">
                  Need help? Call
                  ${escapeHtml(
                    company.mobileNumber
                  )}
                </div>
              `
              : ""
          }

          <div class="footer-line">
            ************************
          </div>

        </div>

      </div>


      <style>

        .receipt {
          width: 100%;
          margin: 0;
          padding: 0;
          color: #000;
          font-family:
            Arial,
            Helvetica,
            sans-serif;
          font-size: 12px;
          line-height: 1.35;
        }

        .header {
          text-align: center;
          padding-bottom: 5px;
        }

        .company-name {
          font-size: 22px;
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 3px;
          text-transform: uppercase;
        }

        .legal-name {
          font-size: 11px;
          font-weight: 600;
          margin-bottom: 3px;
        }

        .company-detail {
          font-size: 10px;
          line-height: 1.35;
        }

        .receipt-title {
          text-align: center;
          font-size: 14px;
          font-weight: 800;
          letter-spacing: 1px;
          margin: 7px 0;
        }

        .divider {
          width: 100%;
          border-top: 2px solid #000;
          margin: 7px 0;
        }

        .divider.dashed {
          border-top:
            1px dashed #000;
        }

        .row {
          display: flex;
          justify-content:
            space-between;
          align-items: flex-start;
          gap: 8px;
          margin: 2px 0;
        }

        .row span:first-child {
          flex: 1;
        }

        .row strong {
          text-align: right;
          white-space: nowrap;
        }

        .section-title {
          font-size: 11px;
          font-weight: 800;
          margin-bottom: 3px;
          letter-spacing: 0.5px;
        }

        .customer-name {
          font-size: 13px;
          font-weight: 700;
        }

        .small-row {
          font-size: 10px;
          margin-top: 1px;
        }

        .product-heading {
          display: flex;
          justify-content:
            space-between;
          font-size: 10px;
          font-weight: 800;
          padding-bottom: 4px;
        }

        .product {
          padding: 4px 0;
          border-top:
            1px dotted #777;
        }

        .product:first-of-type {
          border-top: none;
        }

        .product-name {
          font-size: 12px;
          font-weight: 700;
          line-height: 1.25;
        }

        .product-code {
          font-size: 9px;
          margin-top: 1px;
        }

        .product-calculation {
          display: flex;
          justify-content:
            space-between;
          align-items: center;
          margin-top: 2px;
          font-size: 11px;
        }

        .product-calculation strong {
          font-size: 12px;
        }

        .totals {
          margin-top: 3px;
        }

        .grand-total {
          display: flex;
          justify-content:
            space-between;
          align-items: center;
          margin-top: 6px;
          padding: 5px 0;
          border-top:
            2px solid #000;
          border-bottom:
            2px solid #000;
          font-size: 18px;
          font-weight: 900;
        }

        .payment-section {
          font-size: 11px;
        }

        .footer {
          text-align: center;
          padding-top: 4px;
        }

        .thank-you {
          font-size: 13px;
          font-weight: 800;
          margin-bottom: 2px;
        }

        .footer-text {
          font-size: 10px;
          line-height: 1.4;
        }

        .footer-line {
          margin-top: 7px;
          font-size: 11px;
          letter-spacing: 1px;
        }

      </style>
    `;

    console.log(
      "Sending receipt print request..."
    );

    const result = await window.electronAPI.printReceipt(html);

    console.log(
      "PRINT RESULT:",
      result
    );

    if (!result?.success) {
      console.error(
        "Receipt printing failed:",
        result?.error
      );

      return;
    }

    console.log(
      "PRINT SUCCESS"
    );

    /*
     * You don't need to call openTill here
     * if electron.js already automatically
     * opens till after successful printing.
     */
  } catch (error) {
    console.error(
      "PRINT BUTTON ERROR:",
      error
    );
  }
};
  useEffect(() => {
    const hasZeroPriceProduct = cart?.some((e) => {
      const price = e?.discountPrice
        ? Number(e?.discountPrice)
        : selectedCustomer?.priceLevel?.[0]?.id === 1
        ? Number(e?.trade_price)
        : selectedCustomer?.priceLevel?.[0]?.id === 2
        ? Number(e?.warehouse_price)
        : selectedCustomer?.priceLevel?.[0]?.id === 4
        ? Number(e?.diamond)
        : Number(e?.retail_price);

      return Number(price) === 0;
    });

    if (hasZeroPriceProduct) {
      notification.error({
        message: "Invalid Price",
        description: "One or more products in the cart have a price of 0.",
        placement: "bottomRight",
      });
      playBeep();
    }
  }, [cart]);

  const vat = useSelector((state) => state.loginReducer.vat);

  const returnInvoices = useSelector(
    (state) => state.loginReducer.dayReturnInvoiceOfEmployee
  );
  const todayEmpClaimInvoices = useSelector(
    (state) => state.loginReducer.todayEmployeeClaimInvoices
  );
  const todayEmpWarrantyInvoices = useSelector(
    (state) => state.loginReducer.todayEmployeeWarrantyInvoices
  );

  const selectedInvoice = useSelector(
    (state) => state.loginReducer.selectedInvoice
  );

  const selectedCustomer = useSelector(
    (state) => state.loginReducer.selectedCustomer
  );

  const paymentMethod = useSelector(
    (state) => state.loginReducer.paymentMethod
  );

  const allInvoices = useSelector((state) => state.loginReducer.allInvoices);

  const allReturnInvoices = useSelector(
    (state) => state.loginReducer.allReturnInvoices
  );

  const totalRevenue = useSelector((state) => state.loginReducer.totalRevenue);
  const totalOrders = useSelector((state) => state.loginReducer.totalOrders);
  const Walkins = useSelector((state) => state.loginReducer.totalWalkins);

  const [hover, setHover] = useState(null);
  const [showProfit, setShowProfit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [checkOutModal, setCheckOutModal] = useState(false);
  const [exchangeInvoiceVisible, setExchangeInvoiceVisible] = useState(false);
  const [onlineModalVisible, setOnlineModalVisible] = useState(false);
  const [showData, setShowData] = useState("total");
  const [chequeModalVisible, setChequeModalVisible] = useState(false);
  const [creditAccountModal, setCreditAccountModal] = useState(false);
  const [cardModalVisible, setCardModalVisible] = useState(false);
  const [optionModal, setOptionModal] = useState(false);
  const [printInvoiceData, setPrintInvoiceData] = useState("");
  const [productText, setProductText] = useState("");
  const [productText2, setProductText2] = useState("");
  const [lessAmount, setLessAmount] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [paymentMethodDetails, setPaymentMethodDetails] = useState("");
  const [openEditCartDetailModal, setOpenEditCartDetailModal] = useState(false);
  const [deductBalanceOption, setDeductBalanceOption] = useState("");
  const [pdfDownloadView, setPdfDownloadView] = useState(false);
  const [saleRevenue, setSaleRevenue] = useState({
    today: 0,
    monthly: 0,
    total: 0,
  });
  const [totalOrder, setTotalOrders] = useState({
    today: 0,
    monthly: 0,
    total: 0,
  });

  const [totalWalkins, setTotalWalkins] = useState({
    today: 0,
    monthly: 0,
    total: 0,
  });
  const [creditBalance, setCreditBalance] = useState({
    today: 0,
    total: 0,
  });
  const [showSaleInvoices, setShowSaleInvoices] = useState({
    invoices: true,
    returnInvoices: false,
    claimInvoices: false,
    warrantyInvoices: false,
  });
  const [successfulTransactionModal, setSuccessfulTransactionModal] =
    useState(false);
  const [creditModal, setCreditModal] = useState(false);
  const [isSaleConfirmed, setIsSaleConfirmed] = useState(false);
  const [onlineReferenceId, setOnlineReferenceId] = useState("");
  const [cardTransactionId, setCardTransactionId] = useState("");
  const [creditDays, setCreditDays] = useState(0);
  const [isVat, setIsVat] = useState({
    selected: false,
  });
  const [isVatMargin, setIsVatMargin] = useState({
    selected: false,
  });
  const [specialDiscount, setSpecialDiscount] = useState({
    selected: false,
    value: "0",
  });
  const [chequeDetails, setChequeDetails] = useState({
    chequeNo: "",
    bankName: "",
    day: "",
    month: "",
    year: "",
  });
  const [text, setText] = useState("");
  const { setSelectedInvoice } = useContext(SELECTED_INVOICES);
  const { selectCustomerId, setSelectedCustomerId } =
    useContext(SELECTED_CUSTOMER);
  const [warrantyData, setWarrantyData] = useState(["Yes", "No"]);
  const [selectedWarranty, setSelectedWarranty] = useState("select");

  const [approvedByAdmin, setApprovedByAdmin] = useState(false);
  const [openingBalanceModalVisible, setOpeningBalanceModalVisible] =
    useState(false);
  const [paymentMethodModal, setPaymentMethodModal] = useState(false);
  const [selectedSearch, setSelectedSearch] = useState("products");
  const [searchProducts, setSearchProducts] = useState([]);
  const [searchCustomers, setSearchCustomers] = useState([]);
  const [searchInvoices, setSearchInvoices] = useState([]);
  const [invoiceDetailModal, setInvoiceDetailModal] = useState(false);
  const [openCreditLimitWarningModal, setOpenCreditLimitWarningModal] =
    useState(false);
const [modalVisible, setModalVisible] = useState(false);
  const [selectedInvoiceforFilter, setSelectedInvoiceforFilter] = useState(null);
  // const [isEdit,setIsEdit] = useState(false)
  const handleViewInvoiceDetails = (invoice) => {
    dispatch(viewSelectedInvoice(invoice));
    setInvoiceDetailModal(true);
  };

  useEffect(() => {
    // getTodayInvoices();
    getCustomers();
    getVat();
    // getAllInvoices();
    // getTodayExchangeInvoices();
    // getAllExchangeInvoices();
    // getAllReturnInvoices();
    // getTodayReturnInvoices();
    // getTrashProducts();
    // getAllSuppliers();
  }, []);
  // const [barcodeRead, setBarcodeRead] = useState("");

  // const barcode = {
  //   timing: 0,
  //   data: "",
  // };

  // const barcodeReaded = () => {
  //   if (barcode.data.length > 0) {
  //     let barcodeNumber = barcode.data.trim();

  //     if (barcodeNumber.includes("Enter")) {
  //       barcodeNumber = barcodeNumber.split("Enter")[0].trim();

  //       console.log(barcodeNumber, "split");

  //       let product = products.find((e) => e.barcode === barcodeNumber);

  //       if (product) {
  //         handleSelectProduct(product);
  //       }
  //     } else {
  //       let barcodeNumber = barcode.data.trim();
  //       let product = products.find((e) => e.barcode === barcodeNumber);

  //       if (product) {
  //         handleSelectProduct(product);
  //       }
  //     }
  //   }
  // };

  // useEffect(() => {

  //   const handleKeyPress = (e) => {

  //       console.log(barcode.data,"dataaaa")

  //       barcode.data += e.key;
  //       barcode.timing = e.timeStamp;
  //       // clearTimeout(timeout);
  //       console.log(barcode,"barcodeee")

  //       barcodeReaded()

  //     }

  //   // let timeout = setTimeout(barcodeReaded, 100);

  //   window.addEventListener("keydown", handleKeyPress);

  //   return () => {
  //     // clearTimeout(timeout);
  //     window.removeEventListener("keydown", handleKeyPress);
  //   };
  // }, []);

  // useScanDetection({
  //   onComplete: (code) => {
  //     productInputRef.current.blur();

  //     setBarcodeRead(code);
  //   },
  //   minLength: 3,
  // });

  const [highlightedProduct, setHighlightedProduct] = useState(null);

  
  // useEffect(() => {
  //   const func = async () => {
  //     if (barcodeRead) {
  //       console.log("hello", barcodeRead);
  //       productInputRef?.current?.blur();

  //       let product =
  //         products &&
  //         products?.length > 0 &&
  //         products?.find((e) => e?.barcode == barcodeRead);

  //       let dataToken = await sessionStorage.getItem("userData");
  //       dataToken = JSON.parse(dataToken);
  //       let token = dataToken;
  //       const response = await fetch(
  //         `${Base_Uri}getProducts?rawBarcode=${barcodeRead}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       const data = await response.json();
  //       product = data?.data?.[0];
  //       if (product) {
  //         handleSelectProduct(product);

  //         setText("");
  //         const existsInCart = cart?.find(
  //           (item) => item.barcode === product.barcode
  //         );

  //         setHighlightedProduct(product.barcode);
  //         // setTimeout(() => {
  //         //   setHighlightedProduct(null);
  //         // }, 2000);
  //         if (existsInCart) {
  //           // Remove highlight after 2 seconds
  //         }
  //       } else {
  //         notification.error({
  //           message: "Product Not Found",
  //           description: "Product didn't exist product not found or try again",
  //           placement: "bottomRight",
  //         });
  //         playBeep();
  //       }
  //     }
  //     setBarcodeRead("");
  //   };
  //   if (!openEditCartDetailModal) {
  //     func();
  //   }
  // }, [barcodeRead]);
  useEffect(() => {
    if (highlightedProduct) {
      const targetRef = productRefs.current[highlightedProduct];
      if (targetRef) {
        targetRef.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [highlightedProduct]);

  // useEffect(() => {
  //   if (selectedCustomer || (cart && cart.length > 0 && !barcodeRead)) {
  //     // productInputRef?.current?.focus();
  //   }
  // }, [selectedCustomer, cart?.length]);

  useEffect(() => {
    if (exchangeProducts?.customerDetails?.customerName) {
      let selectCustomer =
        customers &&
        customers.length > 0 &&
        customers.filter(
          (e, i) => e?.id == exchangeProducts?.customerDetails?.id
        );

      if (selectCustomer && selectCustomer.length > 0) {
        dispatch(selectInvoicedCustomer(selectCustomer[0]));
      }

      // if (exchangeProducts?.vatAmount) {
      //   setIsVat({
      //     ...isVat,
      //     selected: true,
      //   });
      // } else {
      //   setIsVat({
      //     ...isVat,
      //     selected: false,
      //   });
      // }
      // if (exchangeProducts?.SDAmount) {
      //   setSpecialDiscount({
      //     ...specialDiscount,
      //     selected: true,
      //     value:exchangeProducts?.sdPer
      //   });
      // } else {
      //   setSpecialDiscount({
      //     ...specialDiscount,
      //     selected: false,
      //   });
      // }
    }
  }, [
    exchangeProducts?.customerDetails?.customerName,
    exchangeProducts?.vatAmount,
  ]);

  const getProducts = async () => {
    // setLoading(true)
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    if (token) {
      axios
        .get(`${Base_Uri}getProducts`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let myData = res.data;

          let { data } = myData;

          if (data && data.length > 0) {
            let allProducts = [];

            for (var i = 0; i < data.length; i++) {
              let product = data[i];

              product.id = i + 1;
              product["productName"] = product?.product_name;

              if (product.status == "active") {
                product.status = "Active";
              }

              allProducts.push(product);
            }

            dispatch(updateProducts(allProducts));
          }
        })
        .catch((error) => {
          //console.log(error, "error");
          // setLoading(false)
        });
    }
  };

  const calculateRevenue = () => {
    if (
      (allInvoices && allInvoices.length > 0) ||
      (allReturnInvoices && allReturnInvoices.length > 0)
    ) {
      let discludeReturnInvoice = allInvoices.filter((e, i) => {
        if (
          allReturnInvoices &&
          allReturnInvoices.length > 0 &&
          !allReturnInvoices.some((j) => j?.returnInvoiceRef == e.invoiceNumber)
        ) {
          return e;
        }
        if (allReturnInvoices.length == 0) {
          return e;
        }
      });

      let todayInvoices =
        discludeReturnInvoice &&
        discludeReturnInvoice.length > 0 &&
        discludeReturnInvoice.filter((e, i) => {
          let nowDate = new Date();
          let saleDate = new Date(e.saleDate);

          let nowDay = nowDate.getDate();
          let nowMonth = nowDate.getMonth();
          let nowYear = nowDate.getFullYear();

          let saleDay = saleDate.getDate();
          let saleMonth = saleDate.getMonth();
          let saleYear = saleDate.getFullYear();

          if (
            nowDay == saleDay &&
            nowMonth == saleMonth &&
            nowYear == saleYear
          ) {
            return e;
          }
        });

      let monthlyInvoices =
        discludeReturnInvoice &&
        discludeReturnInvoice.length > 0 &&
        discludeReturnInvoice.filter((e, i) => {
          let nowDate = new Date();
          let saleDate = new Date(e.saleDate);

          let nowMonth = nowDate.getMonth();
          let nowYear = nowDate.getFullYear();

          let saleMonth = saleDate.getMonth();
          let saleYear = saleDate.getFullYear();

          if (nowMonth == saleMonth && nowYear == saleYear) {
            return e;
          }
        });

      let totalCostPrice =
        discludeReturnInvoice &&
        discludeReturnInvoice.length > 0 &&
        discludeReturnInvoice.reduce((previous, current) => {
          return previous + current?.costPrice;
        }, 0);

      let todayCostPrice =
        todayInvoices &&
        todayInvoices.length > 0 &&
        todayInvoices.reduce((previous, current) => {
          return previous + current?.costPrice;
        }, 0);

      let monthlyCostPrice =
        monthlyInvoices &&
        monthlyInvoices.length > 0 &&
        monthlyInvoices.reduce((previous, current) => {
          return previous + current?.costPrice;
        }, 0);

      let salePrice =
        discludeReturnInvoice &&
        discludeReturnInvoice.length > 0 &&
        discludeReturnInvoice.reduce((previous, current) => {
          return previous + current?.total;
        }, 0);

      let monthlySalePrice =
        monthlyInvoices &&
        monthlyInvoices.length > 0 &&
        monthlyInvoices.reduce((previous, current) => {
          return previous + current?.total;
        }, 0);

      let todaySalePrice =
        todayInvoices &&
        todayInvoices.length > 0 &&
        todayInvoices.reduce((previous, current) => {
          return previous + current?.total;
        }, 0);

      let totalDiscount =
        discludeReturnInvoice &&
        discludeReturnInvoice.length > 0 &&
        discludeReturnInvoice.reduce((previous, current) => {
          return previous + current?.discount;
        }, 0);

      let monthlyDiscount =
        monthlyInvoices &&
        monthlyInvoices.length > 0 &&
        monthlyInvoices.reduce((previous, current) => {
          return previous + current?.discount;
        }, 0);

      let todayDiscount =
        todayInvoices &&
        todayInvoices.length > 0 &&
        todayInvoices.reduce((previous, current) => {
          return previous + current?.discount;
        }, 0);

      let revenue = salePrice - totalDiscount - totalCostPrice;

      let todayRevenue = todaySalePrice - todayDiscount - todayCostPrice;

      let monthlyRevenue =
        monthlySalePrice - monthlyDiscount - monthlyCostPrice;

      dispatch(
        updateRevenue({
          today: todayRevenue,
          monthly: monthlyRevenue,
          total: revenue,
        })
      );

      setSaleRevenue({
        ...saleRevenue,
        today: todayRevenue,
        monthly: monthlyRevenue,
        total: revenue,
      });
    }
  };

  const calculateOrders = () => {
    let todayInvoices =
      allInvoices &&
      allInvoices.length > 0 &&
      allInvoices.filter((e, i) => {
        let nowDate = new Date();
        let saleDate = new Date(e.saleDate);

        let nowDay = nowDate.getDate();
        let nowMonth = nowDate.getMonth();
        let nowYear = nowDate.getFullYear();

        let saleDay = saleDate.getDate();
        let saleMonth = saleDate.getMonth();
        let saleYear = saleDate.getFullYear();

        if (nowDay == saleDay && nowMonth == saleMonth && nowYear == saleYear) {
          return e;
        }
      });

    let monthlyInvoices =
      allInvoices &&
      allInvoices.length > 0 &&
      allInvoices.filter((e, i) => {
        let nowDate = new Date();
        let saleDate = new Date(e.saleDate);

        let nowMonth = nowDate.getMonth();
        let nowYear = nowDate.getFullYear();

        let saleMonth = saleDate.getMonth();
        let saleYear = saleDate.getFullYear();

        if (nowMonth == saleMonth && nowYear == saleYear) {
          return e;
        }
      });

    setTotalOrders({
      ...totalOrder,
      today: todayInvoices.length,
      monthly: monthlyInvoices.length,
      total: allInvoices.length,
    });
  };

  const calculateWalkins = () => {
    let differentWalkins = [];

    if (allInvoices && allInvoices.length > 0) {
      allInvoices.forEach((invoice) => {
        const customerId = invoice.customerDetails[0]?.id;

        if (
          !differentWalkins.some(
            (walkin) => walkin.customerDetails[0]?.id === customerId
          )
        ) {
          differentWalkins.push(invoice);
        }
      });
    }

    let todayInvoices =
      allInvoices &&
      allInvoices.length > 0 &&
      allInvoices.filter((e, i) => {
        let nowDate = new Date();
        let saleDate = new Date(e.saleDate);

        let nowDay = nowDate.getDate();
        let nowMonth = nowDate.getMonth();
        let nowYear = nowDate.getFullYear();

        let saleDay = saleDate.getDate();
        let saleMonth = saleDate.getMonth();
        let saleYear = saleDate.getFullYear();

        if (nowDay == saleDay && nowMonth == saleMonth && nowYear == saleYear) {
          return e;
        }
      });

    let todayWalkins = [];

    if (todayInvoices && todayInvoices.length > 0) {
      todayInvoices.forEach((invoice) => {
        const customerId = invoice.customerDetails[0]?.id;

        if (
          !todayWalkins.some(
            (walkin) => walkin.customerDetails[0]?.id === customerId
          )
        ) {
          todayWalkins.push(invoice);
        }
      });
    }

    let monthlyInvoices =
      allInvoices &&
      allInvoices.length > 0 &&
      allInvoices.filter((e, i) => {
        let nowDate = new Date();
        let saleDate = new Date(e.saleDate);

        let nowMonth = nowDate.getMonth();
        let nowYear = nowDate.getFullYear();

        let saleMonth = saleDate.getMonth();
        let saleYear = saleDate.getFullYear();

        if (nowMonth == saleMonth && nowYear == saleYear) {
          return e;
        }
      });

    let monthlyWalkins = [];

    if (monthlyInvoices && monthlyInvoices.length > 0) {
      monthlyInvoices.forEach((invoice) => {
        const customerId = invoice.customerDetails[0]?.id;

        if (
          !monthlyWalkins.some(
            (walkin) => walkin.customerDetails[0]?.id === customerId
          )
        ) {
          monthlyWalkins.push(invoice);
        }
      });
    }

    setTotalWalkins({
      ...totalWalkins,
      today: todayWalkins.length,
      monthly: monthlyWalkins.length,
      total: differentWalkins.length,
    });
  };

  const calculateCredit = () => {
    let todayInvoices =
      allInvoices &&
      allInvoices.length > 0 &&
      allInvoices.filter((e, i) => {
        let nowDate = new Date();
        let saleDate = new Date(e.saleDate);

        let nowDay = nowDate.getDate();
        let nowMonth = nowDate.getMonth();
        let nowYear = nowDate.getFullYear();

        let saleDay = saleDate.getDate();
        let saleMonth = saleDate.getMonth();
        let saleYear = saleDate.getFullYear();

        if (
          nowDay == saleDay &&
          nowMonth == saleMonth &&
          nowYear == saleYear &&
          e?.paymentMethod?.some((e) => e.toLowerCase() == "credit") == "credit"
        ) {
          return e;
        }
      });

    let todayCreditBalance =
      todayInvoices &&
      todayInvoices.length > 0 &&
      todayInvoices.reduce((previous, current) => {
        return previous + current.subtotal;
      }, 0);

    let totalCreditBalance =
      customers &&
      customers.length > 0 &&
      customers.reduce((previous, current) => {
        return previous + (current.creditBalance ? current.creditBalance : 0);
      }, 0);

    setCreditBalance({
      ...creditBalance,
      today: todayCreditBalance ? todayCreditBalance : 0,
      total: totalCreditBalance ? totalCreditBalance : 0,
    });
  };

  useEffect(() => {
    calculateRevenue();
    calculateOrders();
    calculateWalkins();
    if (customers && customers.length > 0) {
      calculateCredit();
    }
  }, [allInvoices.length, allReturnInvoices.length, customers.length]);

  const Header = () => {
    return (
      <View fixed>
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: 10,
            alignItems: "flex-start",
          }}
        >
          <View>
            {(printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin) && (
              <View>
                <View>
                  <Image
                    style={{ height: 50, borderRadius: 10 }}
                    source={{
                      uri: `${Image_Uri}companyImage/${vat?.companyLogo}`,
                    }}
                  />

                  <Text
                    style={{
                      color: "black",
                      fontSize: "14px",
                      marginTop: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "bold",
                    }}
                  >
                    {vat?.nickName||vat?.companyName}
                  </Text>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    {vat?.companyAddress}
                  </Text>

                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    {vat?.city}
                  </Text>

                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    {vat?.postCode}
                  </Text>
                </View>
                <View>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      marginTop: "3px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    Tel: {vat?.mobileNumber}
                  </Text>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    Email: {vat?.companyEmail}
                  </Text>
                </View>
                <View>
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    VAT No: {vat?.vatNumber}
                  </Text>

                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      fontWeight: "normal",
                    }}
                  >
                    Company No: {vat?.companyNumber}
                  </Text>
                </View>
              </View>
            )}
          </View>

          <View>
            <View style={{ alignItems: "center" }}>
              <Image
                src={`${Image_Uri}products/${printInvoiceData?.barcodeImagePath}`}
                style={{
                  height: "35px",
                  width: "150px",
                }}
              />
            </View>

            <View style={{ alignItems: "center", marginTop: "10px" }}>
              <Text
                style={{
                  color: "black",
                  fontSize: "16px",
                  fontFamily: "MyFont",
                  // marginTop:"10px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {(printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin) ? "Invoice" : "Quotation"}
              </Text>
            </View>

            <View>
              {(printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin) && (
                <Text
                  style={{
                    color: "black",
                    fontSize: "10px",
                    fontFamily: "MyFont",
                    marginTop: "10px",
                    fontWeight: "normal",
                    textAlign: "center",
                  }}
                >
                  Invoice no: {printInvoiceData?.invoiceNumber}
                </Text>
              )}

              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  // marginTop:"10px",
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                Date:{" "}
                {new Date(
                  printInvoiceData?.exchangeDate
                    ? printInvoiceData?.exchangeDate
                    : printInvoiceData.saleDate
                ).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </Text>

              <Text
                style={{
                  color: "black",
                  fontSize: "10px",
                  fontFamily: "MyFont",
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                Time:{" "}
                {new Date(
                  printInvoiceData?.exchangeDate
                    ? printInvoiceData?.exchangeDate
                    : printInvoiceData.saleDate
                ).toLocaleTimeString()}
              </Text>

              {(printInvoiceData?.saleReturnDate ||
                printInvoiceData?.exchangeDate) &&
                printInvoiceData?.vatAmount && (
                  <View style={{ marginTop: "10px" }}>
                    <Text
                      style={{
                        color: "black",
                        fontSize: "10px",
                        fontFamily: "MyFont",
                        // marginTop:"10px",
                        fontWeight: "normal",
                        textAlign: "center",
                      }}
                    >
                      Return Inv Ref.:
                      {printInvoiceData?.returnInvoiceRef?.map((e, i) => {
                        return (
                          <Text
                            style={{
                              color: "black",
                              fontSize: "8px",
                              fontFamily: "MyFont",
                              // marginTop:"10px",
                              fontWeight: "normal",
                              textAlign: "center",
                            }}
                          >
                            {e},
                          </Text>
                        );
                      })}
                    </Text>
                  </View>
                )}

              <View style={{ marginTop: "10px" }}>
                <Text
                  style={{
                    color: "black",
                    fontSize: "12px",
                    fontFamily: "MyFont",
                    // marginTop:"10px",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  <Text
                    style={{
                      color: "black",
                      fontSize: "12px",
                      fontFamily: "MyFont",
                      // marginTop:"10px",
                      fontWeight: "bold",
                      textAlign: "center",
                    }}
                  >
                    {/* Bill to:{" "} */}
                    {Array.isArray(printInvoiceData?.paymentMethod)
                      ? printInvoiceData?.paymentMethod
                          .map((e) =>
                            e?.toLowerCase() === "cash"
                              ? "C"
                              : e?.toLowerCase() === "card"
                              ? "CA"
                              : e?.toLowerCase() === "on account"
                              ? "A"
                              : e?.toLowerCase() === "online"
                              ? "B"
                              : e?.toLowerCase() === "cheque"
                              ? "CH"
                              : e?.toLowerCase() === "exchange"
                              ? "E"
                              : e?.toUpperCase()
                          )
                          .join(", ")
                      : printInvoiceData?.status === "Return"
                      ? "R"
                      : ""}
                  </Text>
                </Text>

                <Text
                  style={{
                    color: "black",
                    fontSize: "10px",
                    fontFamily: "MyFont",
                    // marginTop:"10px",
                    fontWeight: "normal",
                    textAlign: "center",
                  }}
                >
                  Account No: {selectedCustomer?.accountNo}
                </Text>

                {(printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin) && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop:"10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    {printInvoiceData?.extCustomer?.Name?(`Customer Name: ${printInvoiceData?.extCustomer?.Name}`):(`Business Name: ${selectedCustomer?.businessName}`)}
                  </Text>
                )}
                {(printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin) && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop:"10px",
                      fontWeight: "normal",
                      // textAlign: "center",
                      width:"200px"
                    }}
                  >
                                        {printInvoiceData?.extCustomer?.Name?(`Address: ${printInvoiceData?.extCustomer?.address}`):(`Address: ${selectedCustomer?.address}, ${selectedCustomer?.city}, ${selectedCustomer?.postalCode}`)}

                   
                  </Text>
                )}
                {((printInvoiceData?.extCustomer?.phonenumber)&&(printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin)) && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop:"10px",
                      fontWeight: "normal",
                      // textAlign: "center",
                      width:"200px"
                    }}
                  >
Phone Number: {printInvoiceData?.extCustomer?.phonenumber}
                   
                  </Text>
                )}

                {((printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin)&&!printInvoiceData?.extCustomer?.Name) && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop:"10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Email: {selectedCustomer?.email}
                  </Text>
                )}

                {(printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin) && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Payment Method:{" "}
                    {Array?.isArray(printInvoiceData?.paymentMethod)
                      ? printInvoiceData?.paymentMethod
                          ?.map((e, i) => e)
                          .join(",")
                      : printInvoiceData?.paymentMethod}
                  </Text>
                )}

                {(printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin) && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Status: {printInvoiceData?.status}
                  </Text>
                )}

                {printInvoiceData?.referenceId && (
                  <Text
                    style={{
                      color: "black",
                      fontSize: "10px",
                      fontFamily: "MyFont",
                      // marginTop: "10px",
                      fontWeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Reference Id: {printInvoiceData?.referenceId}
                  </Text>
                )}

                {printInvoiceData?.transactionId &&
                  (printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin) && (
                    <Text
                      style={{
                        color: "black",
                        fontSize: "10px",
                        fontFamily: "MyFont",
                        // marginTop: "10px",
                        fontWeight: "normal",
                        textAlign: "center",
                      }}
                    >
                      Transaction Id: {printInvoiceData?.transactionId}
                    </Text>
                  )}

                {(printInvoiceData?.vatAmount||printInvoiceData?.isVatMargin) &&
                  Array?.isArray(printInvoiceData?.paymentMethod) &&
                  printInvoiceData?.paymentMethod?.some(
                    (e) => e?.toLowerCase() == "cheque"
                  ) && (
                    <View>
                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Cheque No: {printInvoiceData?.cheque_no}
                      </Text>

                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Bank Name: {printInvoiceData?.bank_name}
                      </Text>

                      <Text
                        style={{
                          color: "black",
                          fontSize: "10px",
                          fontFamily: "MyFont",
                          // marginTop:"10px",
                          fontWeight: "normal",
                          textAlign: "center",
                        }}
                      >
                        Cheque Date:{" "}
                        {new Date(
                          printInvoiceData.clear_date
                        ).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })}
                      </Text>
                    </View>
                  )}
              </View>
            </View>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            borderBottomWidth: 1,
            borderColor: "#000",
            paddingBottom: 5,
            paddingTop: 5,
            border: "1px solid black",
            backgroundColor: "gray",
            alignItems: "center",
            padding: 10,
            marginTop: "20px",
          }}
        >
          <View style={{ flex: 0.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Item
            </Text>
          </View>

          <View style={{ flex: 1.5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Barcode
            </Text>
          </View>

          <View style={{ flex: selectedCustomer?.showDiscount ? 4 : 5 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Product Description
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Qty
            </Text>
          </View>

          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Price
            </Text>
          </View>
          {selectedCustomer?.showDiscount && (
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 8,
                  fontWeight: "bold",
                }}
              >
                Disc
              </Text>
            </View>
          )}
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontFamily: "MyFont", fontSize: 8, fontWeight: "bold" }}
            >
              Amount
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const MyDocument = () => (
    <Document size="A4">
      {/* <Header /> */}

      <Page style={{ padding: "0px 10px" }}>
        <Header />
        {/* Data Rows */}
        <View>
          {printInvoiceData &&
            printInvoiceData?.productDetails &&
            printInvoiceData?.productDetails?.length > 0 &&
            printInvoiceData?.productDetails?.map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderBottomWidth: 1,
                  borderColor: "#000",
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  padding: "3px 10px",
                }}
              >
                <View style={{ flex: 0.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>1</Text>
                </View>

                <View style={{ flex: 1.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item?.barcode}
                  </Text>
                </View>

                <View style={{ flex: selectedCustomer?.showDiscount ? 4 : 5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item?.productName}
                  </Text>
                  <View>
                    {item?.IMEI != "" &&
                      (typeof item?.IMEI == "string" ||
                        typeof item?.IMEI == "object") && (
                        <View
                          style={{
                            display: "flex",
                            gap: 5,
                            flexDirection: "row",
                          }}
                        >
                          <View>
                            <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                              IMEI:
                            </Text>
                          </View>
                          {typeof item?.IMEI == "object" ? (
                            <View>
                              {item?.IMEI?.map((it, ind) => {
                                return (
                                  <View>
                                    <Text
                                      style={{
                                        fontFamily: "MyFont",
                                        fontSize: 8,
                                      }}
                                    >
                                      {it}
                                    </Text>
                                  </View>
                                );
                              })}
                            </View>
                          ) : (
                            <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                              {item?.IMEI}
                            </Text>
                          )}
                        </View>
                      )}
                  </View>
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item?.saleQty}
                  </Text>
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    £
                    {selectedCustomer?.showDiscount
                      ? item?.discountPrice >
                        (printInvoiceData?.customerDetails[0]?.priceLevel[0]
                          ?.id == 1
                          ? item?.trade_price
                          : printInvoiceData?.customerDetails[0]?.priceLevel[0]
                              ?.id == 2
                          ? item?.warehouse_price
                          : printInvoiceData?.customerDetails[0]?.priceLevel[0]
                              ?.id == 4
                          ? item?.diamond
                          : item?.retail_price)
                        ? item?.discountPrice
                        : printInvoiceData?.customerDetails[0]?.priceLevel[0]
                            ?.id == 1
                        ? Number(item?.trade_price).toFixed(2)
                        : printInvoiceData?.customerDetails[0]?.priceLevel[0]
                            ?.id == 2
                        ? Number(item?.warehouse_price).toFixed(2)
                        : printInvoiceData?.customerDetails[0]?.priceLevel[0]
                            ?.id == 4
                        ? Number(item?.diamond).toFixed(2)
                        : Number(item?.retail_price).toFixed(2)
                      : item?.discountPrice
                      ? Number(item?.discountPrice).toFixed(2)
                      : Number(
                          printInvoiceData?.customerDetails[0]?.priceLevel[0]
                            ?.id == 1
                            ? item?.trade_price
                            : printInvoiceData?.customerDetails[0]
                                ?.priceLevel[0]?.id == 2
                            ? item?.warehouse_price
                            : printInvoiceData?.customerDetails[0]
                                ?.priceLevel[0]?.id == 4
                            ? item?.diamond
                            : item?.retail_price
                        )}
                  </Text>
                </View>

                {selectedCustomer?.showDiscount && (
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      £
                      {item.discountPrice <
                      (printInvoiceData?.customerDetails[0]?.priceLevel[0]
                        ?.id == 1
                        ? item?.trade_price
                        : printInvoiceData?.customerDetails[0]?.priceLevel[0]
                            ?.id == 2
                        ? item?.warehouse_price
                        : printInvoiceData?.customerDetails[0]?.priceLevel[0]
                            ?.id == 4
                        ? item?.diamond
                        : item?.retail_price)
                        ? Number(
                            (printInvoiceData?.customerDetails[0]?.priceLevel[0]
                              ?.id == 1
                              ? item?.trade_price
                              : printInvoiceData?.customerDetails[0]
                                  ?.priceLevel[0]?.id == 2
                              ? item?.warehouse_price
                              : printInvoiceData?.customerDetails[0]
                                  ?.priceLevel[0]?.id == 4
                              ? item?.diamond
                              : item?.retail_price) - item?.discountPrice
                          ).toFixed(2)
                        : 0}
                    </Text>
                  </View>
                )}

                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 8,
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    £
                    {item?.discountPrice
                      ? Number(item?.discountPrice * item?.saleQty).toFixed(2)
                      : Number(
                          (printInvoiceData?.customerDetails[0]?.priceLevel[0]
                            ?.id == 1
                            ? item?.trade_price
                            : printInvoiceData?.customerDetails[0]
                                ?.priceLevel[0]?.id == 2
                            ? item?.warehouse_price
                            : printInvoiceData?.customerDetails[0]
                                ?.priceLevel[0]?.id == 4
                            ? item?.diamond
                            : item?.retail_price) * item?.saleQty
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
            ))}

          {/* {(printInvoiceData?.returnSubtotal)?((printInvoiceData?.SDAmount||printInvoiceData?.vatAmount) ?<></>:(printInvoiceData &&
            printInvoiceData?.returnProductDetails &&
            printInvoiceData?.returnProductDetails?.length > 0 &&
            printInvoiceData?.returnProductDetails?.map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderBottomWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  padding: "3px 10px",
                }}
              >
                <View style={{ flex: 0.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>-1</Text>
                </View>

                <View style={{ flex: 1.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item?.barcode}
                  </Text>
                </View>

                <View style={{ flex: selectedCustomer?.showDiscount ? 4 : 5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item?.productName}
                  </Text>
                  {(item?.IMEI &&
                    item?.IMEI?.length > 0) &&
                    Array.isArray(item?.IMEI)?
                    item?.IMEI?.map((e, i) => {
                      return (
                        <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                          {e}
                        </Text>
                      );
                    }):<Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                          {item?.IMEI}
                        </Text>}
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    -{item?.DamageQty ? item?.DamageQty : item?.saleQty}
                  </Text>
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    £ -
                    {selectedCustomer?.showDiscount
                      ? exchangeProducts?.customerDetails?.priceLevel[0]?.id ==
                        1
                        ? Number(item.trade_price).toFixed(2)
                        : exchangeProducts?.customerDetails?.priceLevel[0]
                            ?.id == 2
                        ? Number(item?.warehouse_price).toFixed(2)
                        : exchangeProducts?.customerDetails?.priceLevel[0]
                            ?.id == 4
                        ? Number(item?.diamond).toFixed(2)
                        : Number(item?.retail_price).toFixed(2)
                      : item?.discountPrice
                      ? Number(item?.discountPrice).toFixed(2)
                      : Number(
                          exchangeProducts?.customerDetails?.priceLevel[0]
                            ?.id == 1
                            ? item?.trade_price
                            : exchangeProducts?.customerDetails?.priceLevel[0]
                                ?.id == 2
                            ? item?.warehouse_price
                            : exchangeProducts?.customerDetails?.priceLevel[0]
                                ?.id == 4
                            ? item?.diamond
                            : item?.retail_price
                        ).toFixed(2)}
                  </Text>
                </View>

                {selectedCustomer?.showDiscount && (
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      £ -
                      {item.discountPrice
                        ? Number(
                            (exchangeProducts?.customerDetails?.priceLevel[0]
                              ?.id == 1
                              ? item?.trade_price
                              : exchangeProducts?.customerDetails?.priceLevel[0]
                                  ?.id == 2
                              ? item?.warehouse_price
                              : exchangeProducts?.customerDetails?.priceLevel[0]
                                  ?.id == 4
                              ? item?.diamond
                              : item?.retail_price) - item?.discountPrice
                          ).toFixed(2)
                        : 0}
                    </Text>
                  </View>
                )}

                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 8,
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    £ -
                    {item?.discountPrice
                      ? Number(
                          item?.discountPrice *
                            (item?.DamageQty ? item?.DamageQty : item?.saleQty)
                        ).toFixed(2)
                      : Number(
                          (exchangeProducts?.customerDetails?.priceLevel[0]
                            ?.id == 1
                            ? item?.trade_price
                            : exchangeProducts?.customerDetails?.priceLevel[0]
                                ?.id == 2
                            ? item?.warehouse_price
                            : exchangeProducts?.customerDetails?.priceLevel[0]
                                ?.id == 4
                            ? item?.diamond
                            : item?.retail_price) *
                            (item?.DamageQty ? item?.DamageQty : item?.saleQty)
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
            )))):<></>} */}

          <View
            // key={index}
            style={{
              flexDirection: "row",
              // borderWidth: 1,
              borderColor: "#000",
              padding: "5px 10px",
              borderLeftWidth: 1,
              borderRightWidth: 1,
            }}
          >
            <View style={{ flex: 0.5 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,
                  fontWeight: "bold",
                }}
              >
                {printInvoiceData?.productDetails?.length}
              </Text>
            </View>

            <View
              style={{
                flex: selectedCustomer?.showDiscount ? 5.5 : 6.5,
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,

                  fontWeight: "bold",
                }}
              >
               {printInvoiceData?.returnSubtotal?"Sale ":""} Subtotal
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,
                  fontWeight: "bold",
                }}
              >
                {/* {printInvoiceData?.totalQty} */}
                {printInvoiceData?.productDetails &&
                  printInvoiceData?.productDetails.reduce((a, b) => {
                    return printInvoiceData?.saleReturnDate
                      ? b?.DamageQty
                        ? a + b?.DamageQty
                        : a + b?.saleQty
                      : a + b?.saleQty;
                  }, 0)}
              </Text>
            </View>

            <View style={{ flex: 1 }}>price</View>

            {selectedCustomer?.showDiscount && (
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  £{Number(printInvoiceData?.discount).toFixed(2)}
                </Text>
              </View>
            )}

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 10,
                  fontWeight: "bold",
                }}
              >
                £
                {Number(
                  printInvoiceData?.total - printInvoiceData?.discount
                ).toFixed(2)}
              </Text>
            </View>
          </View>
{printInvoiceData?.SDAmount && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 9, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  Special Discount{" "}
                  {(
                    (printInvoiceData?.SDAmount /
                      (printInvoiceData?.total  -
                        (printInvoiceData?.discount || 0))) *
                    100
                  ).toFixed(2)}
                  %
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  - £{Number(printInvoiceData?.SDAmount).toFixed(2)}
                </Text>
              </View>
            </View>
          )}
          {(printInvoiceData?.vatAmount&&printInvoiceData?.SDAmount ) && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 9, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  Subtotal
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,

                    fontWeight: "bold",
                  }}
                >
                  £{(Number(printInvoiceData?.total) - Number(printInvoiceData?.discount)-Number(printInvoiceData?.SDAmount)).toFixed(2)}
                </Text>
              </View>
            </View>
          )}
          {printInvoiceData?.vatAmount && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 9, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  Vat
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,

                    fontWeight: "bold",
                  }}
                >
                  £{Number(printInvoiceData?.vatAmount).toFixed(2)}
                </Text>
              </View>
            </View>
          )}
           {(printInvoiceData?.returnSubtotal&&(printInvoiceData?.vatAmount||printInvoiceData?.SDAmount)) ?(
                      <View
                        // key={index}
                        style={{
                          flexDirection: "row",
                          // borderWidth: 1,
                          borderLeftWidth: 1,
                          borderRightWidth: 1,
                          borderColor: "#000",
                          borderTopWidth: 1,
                          padding: "5px 10px",
                        }}
                      >
                        <View style={{ flex: 9, alignItems: "center" }}>
                          <Text
                            style={{
                              fontFamily: "MyFont",
                              fontSize: 10,
                              fontWeight: "bold",
                            }}
                          >
                            Total
                          </Text>
                        </View>
          
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontFamily: "MyFont",
                              fontSize: 10,
          
                              fontWeight: "bold",
                            }}
                          >
                         £{(Number(printInvoiceData.vatAmount||0)+(Number((printInvoiceData.total||0) - (printInvoiceData?.discount || 0)))-Number(printInvoiceData?.SDAmount||0)).toFixed(2)}
                          </Text>
                        </View>
                      </View>
                    ):""}

          {(printInvoiceData?.returnSubtotal)&&( (
                       <>
                       {(printInvoiceData &&
            printInvoiceData?.returnProductDetails &&
            printInvoiceData?.returnProductDetails?.length > 0 &&
            printInvoiceData?.returnProductDetails?.map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderTopWidth: 1,
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderColor: "#000",
                  padding: "3px 10px",
                }}
              >
                <View style={{ flex: 0.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>-1</Text>
                </View>

                <View style={{ flex: 1.5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item?.barcode}
                  </Text>
                </View>

                <View style={{ flex: selectedCustomer?.showDiscount ? 4 : 5 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    {item?.productName}
                  </Text>
                  {(item?.IMEI &&
                    item?.IMEI?.length > 0) &&
                    Array.isArray(item?.IMEI)?
                    item?.IMEI?.map((e, i) => {
                      return (
                        <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                          {e}
                        </Text>
                      );
                    }):<Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                          {item?.IMEI}
                        </Text>}
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    -{item?.DamageQty ? item?.DamageQty : item?.saleQty}
                  </Text>
                </View>

                <View style={{ flex: 1 }}>
                  <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                    £ -
                    {selectedCustomer?.showDiscount
                      ? selectedCustomer?.priceLevel[0]?.id ==
                        1
                        ? Number(item.trade_price).toFixed(2)
                        : selectedCustomer?.priceLevel[0]
                            ?.id == 2
                        ? Number(item?.warehouse_price).toFixed(2)
                        : selectedCustomer?.priceLevel[0]
                            ?.id == 4
                        ? Number(item?.diamond).toFixed(2)
                        : Number(item?.retail_price).toFixed(2)
                      : item?.discountPrice
                      ? Number(item?.discountPrice).toFixed(2)
                      : Number(
                          selectedCustomer?.priceLevel[0]
                            ?.id == 1
                            ? item?.trade_price
                            : selectedCustomer?.priceLevel[0]
                                ?.id == 2
                            ? item?.warehouse_price
                            : selectedCustomer?.priceLevel[0]
                                ?.id == 4
                            ? item?.diamond
                            : item?.retail_price
                        ).toFixed(2)}
                  </Text>
                </View>

                {selectedCustomer?.showDiscount && (
                  <View style={{ flex: 1 }}>
                    <Text style={{ fontFamily: "MyFont", fontSize: 8 }}>
                      £ -
                      {item.discountPrice
                        ? Number(
                            (selectedCustomer?.priceLevel[0]
                              ?.id == 1
                              ? item?.trade_price
                              : selectedCustomer?.priceLevel[0]
                                  ?.id == 2
                              ? item?.warehouse_price
                              : selectedCustomer?.priceLevel[0]
                                  ?.id == 4
                              ? item?.diamond
                              : item?.retail_price) - item?.discountPrice
                          ).toFixed(2)
                        : 0}
                    </Text>
                  </View>
                )}

                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: "MyFont",
                      fontSize: 8,
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    £ -
                    {item?.discountPrice
                      ? Number(
                          item?.discountPrice *
                            (item?.DamageQty ? item?.DamageQty : item?.saleQty)
                        ).toFixed(2)
                      : Number(
                          (selectedCustomer?.priceLevel[0]
                            ?.id == 1
                            ? item?.trade_price
                            : selectedCustomer?.priceLevel[0]
                                ?.id == 2
                            ? item?.warehouse_price
                            : selectedCustomer?.priceLevel[0]
                                ?.id == 4
                            ? item?.diamond
                            : item?.retail_price) *
                            (item?.DamageQty ? item?.DamageQty : item?.saleQty)
                        ).toFixed(2)}
                  </Text>
                </View>
              </View>
            )))}
            {printInvoiceData?.returnSd && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 9, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  Special Discount
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  - £{Number(printInvoiceData?.returnSd).toFixed(2)}
                </Text>
              </View>
            </View>
          )}
            {printInvoiceData?.returnVat && (
            <View
              // key={index}
              style={{
                flexDirection: "row",
                // borderWidth: 1,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderColor: "#000",
                borderTopWidth: 1,
                padding: "5px 10px",
              }}
            >
              <View style={{ flex: 9, alignItems: "center" }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,
                    fontWeight: "bold",
                  }}
                >
                  Vat
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "MyFont",
                    fontSize: 10,

                    fontWeight: "bold",
                  }}
                >
                  -£{Number(printInvoiceData?.returnVat).toFixed(2)}
                </Text>
              </View>
            </View>
          )}
                       <View
                      // key={index}
                      style={{
                        flexDirection: "row",
                        // borderWidth: 1,
                        borderColor: "#000",
                        borderWidth: 1,
                        padding: "5px 10px",
                        // borderBottomWidth:1,
                        // backgroundColor: "#DDD",
                        // opacity: 0.7,
                      }}
                    >
                      <View style={{ flex: 9, alignItems:"center"}}>
                        <Text
                          style={{
                            fontFamily: "MyFont",
                            fontSize: 10,
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          Return Subtotal
                        </Text>
                      </View>
          
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontFamily: "MyFont",
                            fontSize: 10,
                            fontWeight: "bold",
                            color:"black"
                          }}
                        >
                          -£{(printInvoiceData?.returnSubtotal||0).toFixed(2)} 
                        </Text>
                      </View>
                    </View>
                       </> 
                      ))}

          <View
            // key={index}
            style={{
              flexDirection: "row",
              // borderWidth: 1,
              borderColor: "#000",
              borderWidth: 1,
              padding: "5px 10px",
              // borderBottomWidth:1,
              backgroundColor: "#DDD",
              opacity: 0.7,
            }}
          >
            <View style={{ flex: 9, alignItems: "center" }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 12,
                  color: "red",
                  fontWeight: "bold",
                }}
              >
               Grand Total
              </Text>
            </View>

            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontFamily: "MyFont",
                  fontSize: 12,
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                £{Number(printInvoiceData?.subtotal).toFixed(2)}
              </Text>
            </View>
          </View>

          {printInvoiceData?.isVatMargin? <View style={{width:"100%",marginTop:10}}>
                                <Text style={{
                                                fontFamily: "MyFont",
                                                fontSize: 10,
                                                fontWeight: "500",
                                                color:"black"
                                              }}>Note: Goods are sold under UK marginal VAT Scheme</Text>
                              </View>:<></>}
        </View>
      </Page>
    </Document>
  );

  const getTodayInvoices = async () => {
    if (userData && userData.id) {
      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      axios
        .get(`${Base_Uri}getInvoices/${userData.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          if (!res?.status) {
            message.info(res.message);
            return;
          }
          let { data } = res.data;

          data =
            data &&
            data.length > 0 &&
            data.map((e, i) => {
              return {
                ...e,
                id: e._id,
              };
            });

          data =
            data &&
            data.length > 0 &&
            data.sort(
              (a, b) =>
                new Date(b.saleDate).getTime() - new Date(a.saleDate).getTime()
            );

          dispatch(updateInvoice(data && data.length > 0 ? data : []));
        })
        .catch((error) => {
          //console.log(error, "error");
        });
    }
  };

  const getTodayExchangeInvoices = async () => {
    if (userData) {
      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      axios
        .get(`${Base_Uri}getExchangeInvoices/${userData.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          if (!res?.status) {
            message.info(res.message);
            return;
          }

          let { data } = res.data;

          data =
            data &&
            data.length > 0 &&
            data.map((e, i) => {
              return {
                ...e,
                id: e._id,
              };
            });

          dispatch(
            updatetodayEmployeeExchangeInvoice(
              data && data.length > 0 ? data : []
            )
          );
        })
        .catch((error) => {
          //console.log(error, "error");
        });
    }
  };

  const getAllExchangeInvoices = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getAllExchangeInvoices`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        if (!res?.status) {
          message.info(res.message);
          return;
        }

        let { data } = res.data;
        data =
          data &&
          data.length > 0 &&
          data.map((e, i) => {
            return {
              ...e,
              id: e._id,
            };
          });

        dispatch(updateAllExchangeInvoice(data && data.length > 0 ? data : []));
      })
      .catch((error) => {
        //console.log(error, "error");
      });
  };

  const getTrashProducts = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getTrashProducts`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        if (data.status) {
          dispatch(updateTrashProducts(data.data));
        }
      });
  };

  const getAllSuppliers = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getSuppliers`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        if (data.status) {
          let suppliers = data.data;

          dispatch(
            updateSuppliers(suppliers && suppliers.length > 0 ? suppliers : [])
          );
        }
      })
      .catch((error) => {
        //console.log(error, "error");
      });
  };

  const getTodayReturnInvoices = async () => {
    if (userData) {
      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      axios
        .get(`${Base_Uri}getReturnInvoices/${userData.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          if (!res?.status) {
            message.info(res.message);
            return;
          }

          let { data } = res.data;

          data =
            data &&
            data.length > 0 &&
            data.map((e, i) => {
              return {
                ...e,
                id: e._id,
              };
            });

          dispatch(
            updateDayReturnInvoiceEmp(data && data.length > 0 ? data : [])
          );
        })
        .catch((error) => {
          //console.log(error, "error");
        });
    }
  };

  const getAllReturnInvoices = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getAllReturnInvoices`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        if (!res?.status) {
          message.info(res.message);
          return;
        }

        let { data } = res.data;
        data =
          data &&
          data.length > 0 &&
          data.map((e, i) => {
            return {
              ...e,
              id: e._id,
            };
          });

        dispatch(updateAllReturnInvoices(data && data.length > 0 ? data : []));
      })
      .catch((error) => {
        //console.log(error, "error");
      });
  };

  const getAllInvoices = async () => {
    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .get(`${Base_Uri}getAllInvoices`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        if (!res?.status) {
          message.info(res.message);
          return;
        }

        let { data } = res.data;
        data =
          data &&
          data.length > 0 &&
          data.map((e, i) => {
            return {
              ...e,
              id: e._id,
            };
          });

        dispatch(updateAllInvoices(data && data.length > 0 ? data : []));
      })
      .catch((error) => {
        //console.log(error, "error");
      });
  };

  const getVat = async () => {
    let data = sessionStorage.getItem("userData");
    data = JSON.parse(data);

    // if (data) {
    let token = data;

    axios
      .get(`${Base_Uri}getVat`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let { data } = res;

        if (data.status) {
          dispatch(updateVat(data.data));
        }
      })
      .catch((error) => {});
  };
  const [isScanning, setIsScanning] = useState(false);

  const getCustomers = async () => {
    let token = await sessionStorage.getItem("userData");
    token = JSON.parse(token);

    axios
      .get(`${Base_Uri}getCustomers`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let { data } = res;

        if (data.status) {
          let customers = data.data;

          dispatch(
            updateCustomers(customers && customers.length > 0 ? customers : [])
          );
        }
      })
      .catch((error) => {
        //console.log(error, "error");
      });
  };

  useScanDetection({
    onComplete: (code) => {
      setIsScanning(false); // Enable input when scanning completes
      productInputRef?.current?.blur();
      setSearchProducts([]);
    },
    minLength: 3,
    onScan: () => {
      setIsScanning(true); // Disable input when scanning starts
    },
  });

  const handleSearchProducts = async (product) => {
    // setProductText(product);

    if (!product?.trim()) {
      setSearchProducts([]);
      return;
    }

    try {
      const useExtendedSearch = product.length > 3; // Only use barcode/sku if length > 3
      //console.log(useExtendedSearch, "useExtendedSearch");
      let dataToken = await sessionStorage.getItem("userData");
      dataToken = JSON.parse(dataToken);
      let token = dataToken;
      const response = await fetch(
        `${Base_Uri}getProducts?search=${encodeURIComponent(
          product
        )}&useExtendedSearch=${useExtendedSearch}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      if (data.status) {
        setSearchProducts(data.data);
      } else {
        setSearchProducts([]);
      }
    } catch (error) {
      console.error("Error searching products:", error);
    }
  };
  // const handleSearchProducts2 = (product) => {
  //   setProductText2(product);

  //   if (!product.trim()) {
  //     setSearchProducts([]);
  //     return;
  //   }

  //   const searchTokens = product.toLowerCase().split(/\s+/);
  //   const useExtendedSearch = product.length > 3; // Only use barcode/sku if length > 3

  //   // Filter and rank products
  //   const filteredProducts = products
  //     .map((e) => {
  //       const { productName, color, sku, barcode, category, subcategory } = e;

  //       // Convert fields to lowercase once
  //       const searchableFields = [
  //         productName?.toLowerCase(),
  //       ].filter(Boolean); // Remove null/undefined values

  //       // Count how many tokens match
  //       const matchCount = searchTokens.reduce((count, token) => {
  //         return count + searchableFields.filter((field) => field.includes(token)).length;
  //       }, 0);

  //       return { item: e, rank: matchCount };
  //     })
  //     .filter(({ rank }) => rank > 0) // Remove non-matching items
  //     .sort((a, b) => b.rank - a.rank) // Sort by relevance (higher matches first)
  //     .map(({ item }) => item); // Extract item objects

  //   setSearchProducts(filteredProducts);
  // };

  // //console.log(cart, "carrtttt");

  // Debounce Ref

  // Optimized search function
  const productRefs = useRef({});
  const debounceRef = useRef(null);

  // Optimized search function (fetching from API)
  const handleSearchProducts2 = useCallback((product) => {
    // setProductText2(product);
    //console.log(product);
    if (!product.trim()) {
      setSearchProducts([]);
      return;
    }

    // Cancel previous debounce call
    if (debounceRef.current) {
      debounceRef.current.cancel();
    }

    if (barcodeRead) {
      setSearchProducts([]);
      return;
    }

    // Debounce API request
    debounceRef.current = debounce(async () => {
      try {
        let data = await sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;
        setLoading(true);
        const response = await axios.get(
          `${Base_Uri}getProducts?search=${product}&product=1`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        !barcodeRead && setSearchProducts(response.data.data);
      } catch (error) {
        console.error("Search error:", error);
        setSearchProducts([]);
      } finally {
        setLoading(false);
      }
    }, 300);

    debounceRef.current();
  }, []);
  const closeCheckoutModal = () => {
    setCheckOutModal(false);
  };

  let chequeDate;

  const handleConfirmSale = async (reason, days) => {
    if (!paymentMethodDetails?.transactionId && paymentMethodDetails?.card) {
      message.info("Write Transaction Id");
      return;
    }

    if (paymentMethodDetails?.cheque) {
      if (!paymentMethodDetails?.chequeDetails?.chequeNo) {
        message.info("cheque number is missing");
        return;
      }

      if (!paymentMethodDetails?.chequeDetails?.bankName) {
        message.info("Bank Name is missing");
        return;
      }

      if (!paymentMethodDetails?.chequeDetails?.day) {
        message.info("cheque day is missing");
        return;
      }
      if (!paymentMethodDetails?.chequeDetails?.month) {
        message.info("cheque month is missing");
        return;
      }
      if (!paymentMethodDetails?.chequeDetails?.year) {
        message.info("cheque year is missing");
        return;
      }

      let date = new Date(
        `${paymentMethodDetails?.chequeDetails?.month}/${paymentMethodDetails?.chequeDetails?.day}/${paymentMethodDetails?.chequeDetails?.year}`
      );

      if (date == "Invalid Date") {
        message.info("Invalid Date");
        return;
      }
      chequeDate = date;
    }
    let vatAmount = isVat?.selected
      ? (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100
      : 0;

    let specialDiscountAmount =
      specialDiscount?.selected && isVat?.selected
        ? (((totalAmount - discount) * specialDiscount?.value) / 100)
        //  *
        //   (1 + vat.vatRate / 100)
        : specialDiscount?.selected && !isVat?.selected
        ? ((totalAmount - discount) * specialDiscount.value) / 100
        : 0;

    let total =
      (paymentMethodDetails?.cash ? Number(paymentMethodDetails?.cash) : 0) +
      (paymentMethodDetails?.card ? Number(paymentMethodDetails?.card) : 0) +
      (paymentMethodDetails?.online
        ? Number(paymentMethodDetails?.online)
        : 0) +
      (paymentMethodDetails?.cheque ? Number(paymentMethodDetails?.cheque) : 0);

    let additional =
      total +
      (paymentMethodDetails?.credit
        ? Number(paymentMethodDetails?.credit)
        : 0) -
      Number((totalAmount - discount + vatAmount - specialDiscountAmount).toFixed(2));
        let haveJobDetails = JobDetails&&Object.keys(JobDetails).length !=0
    let dataToSend = {
      customerDetails: selectedCustomer,
      productDetails: cart,
      total: totalAmount,
      employeeId: userData.id,
      discount: discount,
      customerName: selectedCustomer.customerName,
      totalItems: cart.length,
      totalQty: totalQty,
      subtotal: Number((totalAmount - discount + vatAmount - specialDiscountAmount).toFixed(2)),
      employeeDetails: userData,
      costPrice: costPrice,
      saleDate: new Date(),
      customerType: customerType,
      status: "Sale",
      cheque_no: paymentMethodDetails?.chequeDetails?.chequeNo,
      SDAmount: specialDiscountAmount,
      vatAmount: vatAmount,
      isVatMargin: isVatMargin.selected||false,
      vatNumber: vatAmount ? vat?.vatNumber : "",
      companyNumber: vatAmount ? vat?.companyNumber : "",
      bank_name: paymentMethodDetails?.chequeDetails?.bankName,
      clear_date: chequeDate,
      paymentMethod: [
        Number(paymentMethodDetails?.cash) ? "cash" : "",
        Number(paymentMethodDetails?.card) ? "card" : "",
        Number(paymentMethodDetails?.online) ? "online" : "",
        Number(paymentMethodDetails?.cheque) ? "cheque" : "",
        Number(paymentMethodDetails?.credit) ? "on Account" : "",
      ].filter((method) => method !== "" && method !== 0),
      reason: reason ? reason : "",
      transactionId: paymentMethodDetails?.transactionId,
      additionalAmount: additional,
      cash: paymentMethodDetails?.cash ? Number(paymentMethodDetails?.cash) : 0,
      credit: paymentMethodDetails?.credit
        ? Number(paymentMethodDetails?.credit)
        : 0,
      card: paymentMethodDetails?.card ? Number(paymentMethodDetails?.card) : 0,
      online: paymentMethodDetails?.online
        ? Number(paymentMethodDetails?.online)
        : 0,
      cheque: paymentMethodDetails?.cheque
        ? Number(paymentMethodDetails?.cheque)
        : 0,
        extCustomer:extraCustomerInfo,
        job:haveJobDetails,
        JobDetails
    };

    let method =
      dataToSend &&
      dataToSend?.paymentMethod &&
      dataToSend?.paymentMethod?.length > 0 &&
      dataToSend?.paymentMethod?.filter((e, i) => e);

    dataToSend.paymentMethod = method;

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    setLoading(true);
    axios
      .post(`${Base_Uri}createInvoice`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        if (!data.status) {
          message.info(data.message);
          setLoading(false);
          return;
        }

        // console.log(data.data, "-==========>");

        setPrintInvoiceData(data.data);
        console.log(data.data,"data.data")
        console.log(vat,"vat")
        setSuccessfulTransactionModal(true);
        // closeSuccessfulTransactionModal()
        // dispatch(selectInvoicedCustomer(""));
    dispatch(updateCart([]));
    setLessAmount(false);
    setSelectedOption("");
    setIsVat(false);
    dispatch(updateExhangeProducts({}));
    setSpecialDiscount({
      ...specialDiscount,
      selected: false,
    });
    setIsVat({
      ...isVat,
      selected: false,
    });
    setIsVatMargin({
      selected: false,
    });
        // handleCloseSuccessfullTransactionModal()
        // getCustomers();
        // getTodayInvoices();
        // getAllInvoices();
        // getProducts();
        setCreditDays("");
        setOnlineReferenceId("");
        setCardTransactionId("");
        setChequeDetails({
          bankName: "",
          chequeNo: "",
        });
        setCheckOutModal(false);
        setPaymentMethodModal(false);
        setOpenCreditLimitWarningModal(false);
        setOnlineModalVisible(false);
        setChequeModalVisible(false);
        setCardModalVisible(false);
        setCreditModal(false);
        setLoading(false);
        setExtraCustomerInfo({})
    //     setSpecialDiscount({
    //   ...specialDiscount,
    //   selected: false,
    // });
    // setIsVat({
    //   ...isVat,
    //   selected: false,
    // });
    //  dispatch(selectInvoicedCustomer(""));
    // dispatch(updateCart([]));
    // setLessAmount(false);
    // setSelectedOption("");
    // setIsVat(false);
    // dispatch(updateExhangeProducts({}));
        setSpecialDiscount({
    selected: false,
    value: "0",
  })
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleConfirmSaleupdate = async (reason, days) => {
    if (!paymentMethodDetails?.transactionId && paymentMethodDetails?.card) {
      message.info("Write Transaction Id");
      return;
    }

    if (paymentMethodDetails?.cheque) {
      if (!paymentMethodDetails?.chequeDetails?.chequeNo) {
        message.info("cheque number is missing");
        return;
      }

      if (!paymentMethodDetails?.chequeDetails?.bankName) {
        message.info("Bank Name is missing");
        return;
      }

      if (!paymentMethodDetails?.chequeDetails?.day) {
        message.info("cheque day is missing");
        return;
      }
      if (!paymentMethodDetails?.chequeDetails?.month) {
        message.info("cheque month is missing");
        return;
      }
      if (!paymentMethodDetails?.chequeDetails?.year) {
        message.info("cheque year is missing");
        return;
      }

      let date = new Date(
        `${paymentMethodDetails?.chequeDetails?.month}/${paymentMethodDetails?.chequeDetails?.day}/${paymentMethodDetails?.chequeDetails?.year}`
      );

      if (date == "Invalid Date") {
        message.info("Invalid Date");
        return;
      }
      chequeDate = date;
    }
    let vatAmount = isVat?.selected
      ? (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) )* vat.vatRate) / 100
      : 0;

    let specialDiscountAmount =
      specialDiscount?.selected && isVat?.selected
        ? (((totalAmount - discount) * specialDiscount?.value) / 100) 
        // *
        //   (1 + vat.vatRate / 100)
        : specialDiscount?.selected && !isVat?.selected
        ? ((totalAmount - discount) * specialDiscount.value) / 100
        : 0;

    let total =
      (paymentMethodDetails?.cash ? Number(paymentMethodDetails?.cash) : 0) +
      (paymentMethodDetails?.card ? Number(paymentMethodDetails?.card) : 0) +
      (paymentMethodDetails?.online
        ? Number(paymentMethodDetails?.online)
        : 0) +
      (paymentMethodDetails?.cheque ? Number(paymentMethodDetails?.cheque) : 0);

    let additional =
      total +
      (paymentMethodDetails?.credit
        ? Number(paymentMethodDetails?.credit)
        : 0) -
       Number((totalAmount - discount + vatAmount - specialDiscountAmount).toFixed(2));
//console.log(userData,"userData")
    let dataToSend = {
      invoiceNumber:selectedInvoiceforFilter?.invoiceNumber,
      _id:selectedInvoiceforFilter?._id,
      customerDetails: selectedCustomer,
      productDetails: cart,
      total: totalAmount,
      employeeId: userData.id,
      employeeName:userData?.employeeId,
      discount: discount,
      customerName: selectedCustomer.customerName,
      totalItems: cart.length,
      totalQty: totalQty,
      subtotal: totalAmount - discount + vatAmount - specialDiscountAmount,
      employeeDetails: userData,
      costPrice: costPrice,
      saleDate: selectedInvoiceforFilter?.saleDate,
      newDate:Date.now(),
      customerType: customerType,
      status: "Sale",
      cheque_no: paymentMethodDetails?.chequeDetails?.chequeNo,
      SDAmount: specialDiscountAmount,
      vatAmount: vatAmount,
      isVatMargin: isVatMargin.selected||false,
      vatNumber: vatAmount ? vat?.vatNumber : "",
      companyNumber: vatAmount ? vat?.companyNumber : "",
      bank_name: paymentMethodDetails?.chequeDetails?.bankName,
      clear_date: chequeDate,
      paymentMethod: [
        Number(paymentMethodDetails?.cash) ? "cash" : "",
        Number(paymentMethodDetails?.card) ? "card" : "",
        Number(paymentMethodDetails?.online) ? "online" : "",
        Number(paymentMethodDetails?.cheque) ? "cheque" : "",
        Number(paymentMethodDetails?.credit) ? "on Account" : "",
      ].filter((method) => method !== "" && method !== 0),
      reason: reason ? reason : "",
      transactionId: paymentMethodDetails?.transactionId,
      additionalAmount: additional,
      cash: paymentMethodDetails?.cash ? Number(paymentMethodDetails?.cash) : 0,
      credit: paymentMethodDetails?.credit
        ? Number(paymentMethodDetails?.credit)
        : 0,
      card: paymentMethodDetails?.card ? Number(paymentMethodDetails?.card) : 0,
      online: paymentMethodDetails?.online
        ? Number(paymentMethodDetails?.online)
        : 0,
      cheque: paymentMethodDetails?.cheque
        ? Number(paymentMethodDetails?.cheque)
        : 0,
        extCustomer:extraCustomerInfo
    };

    let method =
      dataToSend &&
      dataToSend?.paymentMethod &&
      dataToSend?.paymentMethod?.length > 0 &&
      dataToSend?.paymentMethod?.filter((e, i) => e);

    dataToSend.paymentMethod = method;

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    setLoading(true);
    axios
      .put(`${Base_Uri}update/invoice`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // Include other headers as needed
        },
      })
      .then((res) => {
        let data = res.data;

        if (!data.status) {
          message.info(data.message);
          setLoading(false);
          return;
        }

        //console.log(data.data, "-==========>");
        //console.log(cart,"cart")
        //console.log(dataToSend,"dataToSend")

        setPrintInvoiceData(data.data);
        setSuccessfulTransactionModal(true);
        dispatch(updateCart([]));
    setLessAmount(false);
    setSelectedOption("");
    setIsVat(false);
    dispatch(updateExhangeProducts({}));
    setSpecialDiscount({
      ...specialDiscount,
      selected: false,
    });
    setIsVat({
      ...isVat,
      selected: false,
    });
     setIsVatMargin({
      selected: false,
    });
        // getCustomers();
        // getTodayInvoices();
        // getAllInvoices();
        // getProducts();
        setCreditDays("");
        setOnlineReferenceId("");
        setCardTransactionId("");
        setChequeDetails({
          bankName: "",
          chequeNo: "",
        });
        setCheckOutModal(false);
        setPaymentMethodModal(false);
        setExtraCustomerInfo({})
    //     setSpecialDiscount({
    //   ...specialDiscount,
    //   selected: false,
    // });
    // setIsVat({
    //   ...isVat,
    //   selected: false,
    // });
    //  dispatch(selectInvoicedCustomer(""));
    // dispatch(updateCart([]));
    // setLessAmount(false);
    // setSelectedOption("");
    // setIsVat(false);
    // dispatch(updateExhangeProducts({}));
        setOpenCreditLimitWarningModal(false);
        setOnlineModalVisible(false);
        setChequeModalVisible(false);
        setCardModalVisible(false);
        setCreditModal(false);
        setLoading(false);
        setSelectedInvoiceforFilter(null)
        setIsEdit(false)
        setSpecialDiscount({
    selected: false,
    value: "0",
  })
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleConfirmExchangeSale = async (reason, days) => {
    let specialDiscountAmount2 =
          specialDiscount?.selected && isVat?.selected
            ? (((totalAmount - discount) * specialDiscount?.value) / 100) 
            // *
            //   (1 + vat.vatRate / 100)
            : specialDiscount?.selected && !isVat?.selected
            ? ((totalAmount - discount) * specialDiscount.value) / 100
            : 0;
    let subtotal =
      (((Number(totalAmount||0) - Number(discount||0) )+ Number(vatAmount||0))-Number(specialDiscountAmount2||0)) - Number(exchangeProducts.subtotal||0);
    let roundTotal = Math.ceil(subtotal);
    if (Number(roundTotal) < 0) {
      //console.log("Done11")
      if (selectedOption == "cash"||selectedOption=="online"||selectedOption=="card") {
        let vatAmount = isVat?.selected
          ? (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100
          : 0;
        let specialDiscountAmount =
          specialDiscount?.selected && isVat?.selected
            ? (((totalAmount - discount) * specialDiscount?.value) / 100) 
            // *
            //   (1 + vat.vatRate / 100)
            : specialDiscount?.selected && !isVat?.selected
            ? ((totalAmount - discount) * specialDiscount.value) / 100
            : 0;
        let total =
          (paymentMethodDetails?.cash
            ? Number(paymentMethodDetails?.cash)
            : 0) +
          (paymentMethodDetails?.card
            ? Number(paymentMethodDetails?.card)
            : 0) +
          (paymentMethodDetails?.online
            ? Number(paymentMethodDetails?.online)
            : 0) +
          (paymentMethodDetails?.cheque
            ? Number(paymentMethodDetails?.cheque)
            : 0);
let additional =
      total +
      (paymentMethodDetails?.credit
        ? Number(paymentMethodDetails?.credit)
        : 0) -
      Number((totalAmount - discount + vatAmount - specialDiscountAmount).toFixed(2))

        //console.log(additional, "additional");
        let subtotal = totalAmount - discount + vatAmount;
        let exchangeDataToSend = {
          customerDetails: selectedCustomer,
          // additionalAmount: additional,
          productDetails: cart,
          returnProductDetails: exchangeProducts.productDetails,
          employeeId: userData.id,
          customerName: selectedCustomer.customerName,
          employeeDetails: userData,
          exchangeDate: new Date(),
          customerType: customerType,
          status: exchangeProducts?.status,
          vatNumber: vatAmount ? vat?.vatNumber : "",
          companyNumber: vatAmount ? vat?.companyNumber : "",
          paymentMethod: `refund ${selectedOption}`,
          type: vatAmount ? "invoice" : "quotation",
          deductCash: true,
          deductCreditBalance: false,
          returnInvoiceRef: exchangeProducts?.returnInvoiceRef,
          invoiceRefDate: exchangeProducts?.invoiceRefDate,
          total: Number(
            Number(totalAmount) 
          ).toFixed(2),
          discount: Number(
            Number(discount) - Number(exchangeProducts?.discount)
          ).toFixed(2),
          costPrice: Number(costPrice - exchangeProducts?.costPrice).toFixed(2),
          totalItems: cart.length - exchangeProducts?.totalItems,
          totalQty: totalQty - exchangeProducts?.totalQty,
          subtotal: Number(
            Number(totalAmount - discount + vatAmount) -
              Number(exchangeProducts?.subtotal) -
              Number(specialDiscountAmount)
          ).toFixed(2),
          returnSubtotal: exchangeProducts?.subtotal,
          saleSubtotal: Number(
            totalAmount - discount + vatAmount - specialDiscountAmount
          ),
          vatAmount: 
            Number(vatAmount)
          ,
          SDAmount: 
            Number(specialDiscountAmount)
          ,
          returnVat: Number(exchangeProducts?.vatAmount),
          reason: reason ? reason : "",
            returnSd:Number(exchangeProducts?.SDAmount||0),
    returnVat:Number(exchangeProducts?.vatAmount||0),
    extCustomer:extraCustomerInfo
        };

        let data = await sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;

        setLoading(true);

        axios
          .post(`${Base_Uri}createExchangeInvoice`, exchangeDataToSend, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // Include other headers as needed
            },
          })
          .then((res) => {
            let data = res.data;

            if (!data.status) {
              message.info(data.message);
              setLoading(false);
              return;
            }

            setPrintInvoiceData(data.data);

            if (data.status) {
              setSuccessfulTransactionModal(true);
              dispatch(updateCart([]));
    setLessAmount(false);
    setSelectedOption("");
    setIsVat(false);
    dispatch(updateExhangeProducts({}));
    setSpecialDiscount({
      ...specialDiscount,
      selected: false,
    });
    setIsVat({
      ...isVat,
      selected: false,
    });
    setExtraCustomerInfo({})
              // getCustomers();
              // getTodayInvoices();
              // getAllInvoices();
              // getProducts();
              // getAllExchangeInvoices();
              // getTodayExchangeInvoices();
              setCheckOutModal(false);
              setOptionModal(false);
              setExchangeInvoiceVisible(false);
              setOnlineModalVisible(false);
              setPaymentMethodModal(false);
    //           setSpecialDiscount({
    //   ...specialDiscount,
    //   selected: false,
    // });
    // setIsVat({
    //   ...isVat,
    //   selected: false,
    // });
    //  dispatch(selectInvoicedCustomer(""));
    // dispatch(updateCart([]));
    // setLessAmount(false);
    // setSelectedOption("");
    // setIsVat(false);
    // dispatch(updateExhangeProducts({}));
              setOpenCreditLimitWarningModal(false);
              setChequeModalVisible(false);
              setCardModalVisible(false);
              setCreditModal(false);
              setLoading(false);
              setSpecialDiscount({
                ...specialDiscount,
                selected: false,
              });
              setIsVat({
                ...isVat,
                selected: false,
              });
            }
          })
          .catch((error) => {
            setLoading(false);
          });
      } else {
        
        let vatAmount = isVat?.selected
          ? (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) )* vat.vatRate) / 100
          : 0;
        let specialDiscountAmount =
          specialDiscount?.selected && isVat?.selected
            ? (((totalAmount - discount) * specialDiscount?.value) / 100) 
            // *
            //   (1 + vat.vatRate / 100)
            : specialDiscount?.selected && !isVat?.selected
            ? ((totalAmount - discount) * specialDiscount.value) / 100
            : 0;
        let deductAmount = isVat?.selected
          ? (
              totalAmount -
              exchangeProducts?.subtotal -
              discount +
              ((totalAmount - discount) * vat.vatRate) / 100
            ).toFixed(2)
          : Number(totalAmount - discount - exchangeProducts?.subtotal).toFixed(
              2
            );

        let exchangeDataToSend = {
          customerDetails: selectedCustomer,
          productDetails: cart,
          returnProductDetails: exchangeProducts.productDetails,
          employeeId: userData.id,
          customerName: selectedCustomer.customerName,
          employeeDetails: userData,
          exchangeDate: new Date(),
          customerType: customerType,
          status: exchangeProducts?.status,
          vatNumber: vatAmount ? vat?.vatNumber : "",
          companyNumber: vatAmount ? vat?.companyNumber : "",
          paymentMethod: "Credit Note",
          deductAmount: Math.abs(deductAmount),
          type: vatAmount ? "invoice" : "quotation",
          deductCash: false,
          reason: reason ? reason : "",
          deductCreditBalance: true,
          selectedDeductedBalanceOption: deductBalanceOption,
          returnInvoiceRef: exchangeProducts?.returnInvoiceRef,
          invoiceRefDate: exchangeProducts?.invoiceRefDate,
          total: Number(
            Number(totalAmount) 
          ).toFixed(2),
          discount: Number(
            Number(discount) - Number(exchangeProducts?.discount)
          ).toFixed(2),
          costPrice: Number(costPrice - exchangeProducts?.costPrice).toFixed(2),
          totalItems: cart.length - exchangeProducts?.totalItems,
          totalQty: totalQty - exchangeProducts?.totalQty,
          subtotal: Number(
            Number(totalAmount - discount + vatAmount) -
              Number(exchangeProducts?.subtotal) -
              Number(specialDiscountAmount)
          ).toFixed(2),
          returnSubtotal: exchangeProducts?.subtotal,
          saleSubtotal: Number(
            totalAmount - discount + vatAmount - specialDiscountAmount
          ),
          vatAmount:
            Number(vatAmount) 
          ,
          SDAmount: 
            Number(specialDiscountAmount)
          ,
          returnVat: Number(exchangeProducts?.vatAmount),
         returnSd:Number(exchangeProducts?.SDAmount||0),
    returnVat:Number(exchangeProducts?.vatAmount||0),
    extCustomer:extraCustomerInfo
        };

        let data = await sessionStorage.getItem("userData");
        data = JSON.parse(data);
        let token = data;

        setLoading(true);

        axios
          .post(`${Base_Uri}createExchangeInvoice`, exchangeDataToSend, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json", // Include other headers as needed
            },
          })
          .then((res) => {
            let data = res.data;

            if (!data.status) {
              message.info(data.message);
              setLoading(false);
              return;
            }

            setPrintInvoiceData(data.data);

            if (data.status) {
              setSuccessfulTransactionModal(true);
              dispatch(updateCart([]));
    setLessAmount(false);
    setSelectedOption("");
    setIsVat(false);
    dispatch(updateExhangeProducts({}));
    setSpecialDiscount({
      ...specialDiscount,
      selected: false,
    });
    setIsVat({
      ...isVat,
      selected: false,
    });
    setExtraCustomerInfo({})
              // getCustomers();
              // getTodayInvoices();
              // getAllInvoices();
              // getProducts();
              setCheckOutModal(false);
              setOptionModal(false);
              setPaymentMethodModal(false);
    //           setSpecialDiscount({
    //   ...specialDiscount,
    //   selected: false,
    // });
    // setIsVat({
    //   ...isVat,
    //   selected: false,
    // });
    //  dispatch(selectInvoicedCustomer(""));
    // dispatch(updateCart([]));
    // setLessAmount(false);
    // setSelectedOption("");
    // setIsVat(false);
    // dispatch(updateExhangeProducts({}));
              setOpenCreditLimitWarningModal(false);
              setExchangeInvoiceVisible(false);
              setOnlineModalVisible(false);
              setChequeModalVisible(false);
              setCardModalVisible(false);
              setCreditModal(false);
              setLoading(false);
              setSpecialDiscount({
                value:"0",
                selected: false,
              });
              setIsVat({
                ...isVat,
                selected: false,
              });
            }
          })
          .catch((error) => {
            setLoading(false);
          });
      }
    } else if (Number(roundTotal) > 0) {
      //console.log("Done22")
      if (!paymentMethodDetails?.transactionId && paymentMethodDetails?.card) {
        message.info("Write Transaction Id");
        return;
      }

      if (paymentMethodDetails?.cheque) {
        if (!paymentMethodDetails?.chequeDetails?.chequeNo) {
          message.info("cheque number is missing");
          return;
        }

        if (!paymentMethodDetails?.chequeDetails?.bankName) {
          message.info("Bank Name is missing");
          return;
        }

        if (!paymentMethodDetails?.chequeDetails?.day) {
          message.info("cheque day is missing");
          return;
        }
        if (!paymentMethodDetails?.chequeDetails?.month) {
          message.info("cheque month is missing");
          return;
        }
        if (!paymentMethodDetails?.chequeDetails?.year) {
          message.info("cheque year is missing");
          return;
        }

        let date = new Date(
          `${paymentMethodDetails?.chequeDetails?.month}/${paymentMethodDetails?.chequeDetails?.day}/${paymentMethodDetails?.chequeDetails?.year}`
        );

        if (date == "Invalid Date") {
          message.info("Invalid Date");
          return;
        }
        chequeDate = date;
      }

      let vatAmount = isVat?.selected
        ? (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100
        : 0;
  let specialDiscountAmount =
          specialDiscount?.selected && isVat?.selected
            ? (((totalAmount - discount) * specialDiscount?.value) / 100) 
            // *
            //   (1 + vat.vatRate / 100)
            : specialDiscount?.selected && !isVat?.selected
            ? ((totalAmount - discount) * specialDiscount.value) / 100
            : 0;
      let deductAmount = isVat?.selected
        ? (
            totalAmount -
            exchangeProducts?.subtotal -
            discount +
            ((totalAmount - discount) * vat.vatRate) / 100
          ).toFixed(2)
        : Number(totalAmount - discount - exchangeProducts?.subtotal).toFixed(
            2
          );

      let total =
        (paymentMethodDetails?.cash ? Number(paymentMethodDetails?.cash) : 0) +
        (paymentMethodDetails?.card ? Number(paymentMethodDetails?.card) : 0) +
        (paymentMethodDetails?.online
          ? Number(paymentMethodDetails?.online)
          : 0) +
        (paymentMethodDetails?.cheque
          ? Number(paymentMethodDetails?.cheque)
          : 0);

      let additional =total?
      total -(Number((totalAmount - discount + vatAmount - specialDiscountAmount).toFixed(2))-exchangeProducts?.subtotal):0

        //console.log(additional,"addtionalcec")
        //console.log(total,"totalcec")
        // console.log((paymentMethodDetails?.credit
        //   ? Number(paymentMethodDetails?.credit)
        //   : 0),"creditcec")
          //console.log(Number(totalAmount - discount + vatAmount- specialDiscountAmount),"Number(totalAmount - discount + vatAmount)cec")
//console.log(Number(exchangeProducts?.subtotal),"Number(exchangeProducts?.subtotal)cec")
      let exchangeDataToSend = {
        customerDetails: selectedCustomer,
        productDetails: cart,
        returnProductDetails: exchangeProducts.productDetails,
        employeeId: userData.id,
        customerName: selectedCustomer.customerName,
        employeeDetails: userData,
        exchangeDate: new Date(),
        additionalAmount: additional>0?additional:0,
        customerType: customerType,
        status: exchangeProducts?.status,
        type: vatAmount ? "invoice" : "quotation",
        vatNumber: vatAmount ? vat?.vatNumber : "",
        companyNumber: vatAmount ? vat?.companyNumber : "",
        bank_name: paymentMethodDetails?.chequeDetails?.bankName,
        clear_date: chequeDate,
        cheque_no: paymentMethodDetails?.chequeDetails?.chequeNo,
        returnInvoiceRef: exchangeProducts?.returnInvoiceRef,
        invoiceRefDate: exchangeProducts?.invoiceRefDate,
        total: Number(
          Number(totalAmount) 
        ).toFixed(2),
        discount: Number(
          Number(discount) - Number(exchangeProducts?.discount)
        ).toFixed(2),
        costPrice: Number(costPrice - exchangeProducts?.costPrice).toFixed(2),
        totalItems: cart.length - exchangeProducts?.totalItems,
        totalQty: totalQty - exchangeProducts?.totalQty,
        subtotal: Number(
          Number(totalAmount - discount + vatAmount) -
            Number(exchangeProducts?.subtotal) -
              Number(specialDiscountAmount)
        ).toFixed(2),
        returnSubtotal: exchangeProducts?.subtotal,
        saleSubtotal: Number(totalAmount - discount + vatAmount),
        vatAmount: 
          Number(vatAmount)
        ,
        SDAmount: 
          Number(specialDiscountAmount)
        ,
        returnVat: Number(exchangeProducts?.vatAmount),
        paymentMethod: [
          Number(paymentMethodDetails?.cash) ? "cash" : "",
          Number(paymentMethodDetails?.card) ? "card" : "",
          Number(paymentMethodDetails?.online) ? "online" : "",
          Number(paymentMethodDetails?.cheque) ? "cheque" : "",
          Number(paymentMethodDetails?.credit) ? "on Account" : "",
        ].filter((method) => method !== "" && method !== 0),
        reason: reason ? reason : "",
        transactionId: paymentMethodDetails?.transactionId,
        cash: paymentMethodDetails?.cash
          ? Number(paymentMethodDetails?.cash)
          : 0,
        credit: paymentMethodDetails?.credit
          ? Number(paymentMethodDetails?.credit)
          : 0,
        card: paymentMethodDetails?.card
          ? Number(paymentMethodDetails?.card)
          : 0,
        online: paymentMethodDetails?.online
          ? Number(paymentMethodDetails?.online)
          : 0,
        cheque: paymentMethodDetails?.cheque
          ? Number(paymentMethodDetails?.cheque)
          : 0,
           returnSd:Number(exchangeProducts?.SDAmount||0),
    returnVat:Number(exchangeProducts?.vatAmount||0),
    extCustomer:extraCustomerInfo
      };

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      setLoading(true);

      axios
        .post(`${Base_Uri}createExchangeInvoice`, exchangeDataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data.status) {
            message.info(data.message);
            setLoading(false);
            return;
          }

          setPrintInvoiceData(data.data);

          if (data.status) {
            setSuccessfulTransactionModal(true);
            dispatch(updateCart([]));
    setLessAmount(false);
    setSelectedOption("");
    setIsVat(false);
    dispatch(updateExhangeProducts({}));
    setSpecialDiscount({
      ...specialDiscount,
      selected: false,
    });
    setIsVat({
      ...isVat,
      selected: false,
    });
    setExtraCustomerInfo({})
            // getCustomers();
            // getTodayInvoices();
            // getAllInvoices();
            // getProducts();
            setCheckOutModal(false);

            setPaymentMethodModal(false);
    //         setSpecialDiscount({
    //   ...specialDiscount,
    //   selected: false,
    // });
    // setIsVat({
    //   ...isVat,
    //   selected: false,
    // });
    //  dispatch(selectInvoicedCustomer(""));
    // dispatch(updateCart([]));
    // setLessAmount(false);
    // setSelectedOption("");
    // setIsVat(false);
    // dispatch(updateExhangeProducts({}));
            setOpenCreditLimitWarningModal(false);
            setOptionModal(false);
            setExchangeInvoiceVisible(false);
            setOnlineModalVisible(false);
            setChequeModalVisible(false);
            setCardModalVisible(false);
            setCreditModal(false);
            setLoading(false);
            setSpecialDiscount({
              value:"0",
              selected: false,
            });
            setIsVat({
              ...isVat,
              selected: false,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      //console.log("Done33")
      let vatAmount = isVat?.selected
        ? (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100
        : 0;
          let specialDiscountAmount =
          specialDiscount?.selected && isVat?.selected
            ? (((totalAmount - discount) * specialDiscount?.value) / 100) 
            // *
            //   (1 + vat.vatRate / 100)
            : specialDiscount?.selected && !isVat?.selected
            ? ((totalAmount - discount) * specialDiscount.value) / 100
            : 0;

      let deductAmount = isVat?.selected
        ? (
            totalAmount -
            exchangeProducts?.subtotal -
            discount +
            ((totalAmount - discount) * vat.vatRate) / 100
          ).toFixed(2)
        : Number(totalAmount - discount - exchangeProducts?.subtotal).toFixed(
            2
          );

      let exchangeDataToSend = {
        customerDetails: selectedCustomer,
        productDetails: cart,
        returnProductDetails: exchangeProducts.productDetails,
        employeeId: userData.id,
        customerName: selectedCustomer.customerName,
        employeeDetails: userData,
        exchangeDate: new Date(),
        customerType: customerType,
        status: exchangeProducts?.status,
        vatNumber: vatAmount ? vat?.vatNumber : "",
        companyNumber: vatAmount ? vat?.companyNumber : "",
        paymentMethod: ["Exchange"],
        returnInvoiceRef: exchangeProducts?.returnInvoiceRef,
        invoiceRefDate: exchangeProducts?.invoiceRefDate,
        total: Number(
          Number(totalAmount) 
        ).toFixed(2),
        discount: Number(
          Number(discount) - Number(exchangeProducts?.discount)
        ).toFixed(2),
        costPrice: Number(costPrice - exchangeProducts?.costPrice).toFixed(2),
        totalItems: cart.length - exchangeProducts?.totalItems,
        totalQty: totalQty - exchangeProducts?.totalQty,
        subtotal: Number(
          Number(totalAmount - discount + vatAmount) -
            Number(exchangeProducts?.subtotal) -
              Number(specialDiscountAmount)
        ).toFixed(2),
        returnSubtotal: exchangeProducts?.subtotal,
        saleSubtotal: Number(totalAmount - discount + vatAmount),
        vatAmount: Number(
          Number(vatAmount) 
        ).toFixed(2),
        SDAmount:Number(specialDiscountAmount),
        returnVat: Number(exchangeProducts?.vatAmount),
      returnSd:Number(exchangeProducts?.SDAmount||0),
    returnVat:Number(exchangeProducts?.vatAmount||0),
    extCustomer:extraCustomerInfo
      };

      let data = await sessionStorage.getItem("userData");
      data = JSON.parse(data);
      let token = data;

      setLoading(true);

      axios
        .post(`${Base_Uri}createExchangeInvoice`, exchangeDataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Include other headers as needed
          },
        })
        .then((res) => {
          let data = res.data;

          if (!data.status) {
            message.info(data.message);
            setLoading(false);
            return;
          }

          setPrintInvoiceData(data.data);

          if (data.status) {
            setSuccessfulTransactionModal(true);
            dispatch(updateCart([]));
    setLessAmount(false);
    setSelectedOption("");
    setIsVat(false);
    dispatch(updateExhangeProducts({}));
    setSpecialDiscount({
      ...specialDiscount,
      selected: false,
    });
    setIsVat({
      ...isVat,
      selected: false,
    });
    setExtraCustomerInfo({})
            // getCustomers();
            // getTodayInvoices();
            // getAllInvoices();
            // getProducts();
            setCheckOutModal(false);
            setOptionModal(false);
            setPaymentMethodModal(false);
    //         setSpecialDiscount({
    //   ...specialDiscount,
    //   selected: false,
    // });
    // setIsVat({
    //   ...isVat,
    //   selected: false,
    // });
    //  dispatch(selectInvoicedCustomer(""));
    // dispatch(updateCart([]));
    // setLessAmount(false);
    // setSelectedOption("");
    // setIsVat(false);
    // dispatch(updateExhangeProducts({}));
            setOpenCreditLimitWarningModal(false);
            setExchangeInvoiceVisible(false);
            setOnlineModalVisible(false);
            setChequeModalVisible(false);
            setCardModalVisible(false);
            setCreditModal(false);
            setLoading(false);
            setSpecialDiscount({
              value:"0",
              selected: false,
            });
            setIsVat({
              ...isVat,
              selected: !false,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  };

  const handleSelectProduct = (product) => {
    // if (cart && cart.length > 0 && cart.some((e, i) => e._id == product.tempXId)) {
    //   let newCart = cart.map((e, i) => {
    //     if (e._id == product.tempXId) {
    //       setSearchProducts([]);
    //       return {
    //         ...e,
    //         saleQty: e.saleQty + 1,
    //       };
    //     } else {
    //       setSearchProducts([]);
    //       return e;
    //     }
    //   });
    //   console.log(newCart,"newCart")
    //   dispatch(updateCart(newCart));
    //   setProductText("");
    //   setProductText2("");
    //   setSearchProducts([]);
    //   setBarcodeRead("");
    // } else {
    //   let newProduct = { ...product };
    //   newProduct.saleQty = 1;
    //   let updatedCart = [...cart, newProduct];
    //   dispatch(updateCart(updatedCart));
    //   setProductText("");
    //   setProductText2("");
    //   setSearchProducts([]);
    //   setBarcodeRead("");
    // }
    let newProduct = { ...product };
      newProduct.saleQty = 1;
      const tempXId =  Date.now().toString(36) +Math.random().toString(36).substring(2, 10);
      let updatedCart = [...cart, {...newProduct,tempXId}];
      dispatch(updateCart(updatedCart));
      setProductText("");
      setProductText2("");
      setSearchProducts([]);
      setBarcodeRead("");
  };

  const handleIncreaseProduct = (product) => {
    if (cart && cart.length > 0 && cart.some((e, i) => e.tempXId == product.tempXId)) {
      let newCart = cart.map((e, i) => {
        if (e.tempXId == product.tempXId) {
          return {
            ...e,
            saleQty: e.saleQty + 1,
          };
        } else {
          return e;
        }
      });

      dispatch(updateCart(newCart));
      setText("");
      setSearchProducts([]);
    }
  };
const enqueueBarcode = useBarcodeQueue({
  Base_Uri,
  products,
  cart,
  openEditCartDetailModal,
  handleSelectProduct,
  notification,
  playBeep,
  setHighlightedProduct
});

// When barcodeRead changes (like from scanner)
useEffect(() => {
  if (barcodeRead&&!isEditOpen) {
    enqueueBarcode(barcodeRead);
    setBarcodeRead("");
  }
}, [barcodeRead]);
  const handleDecreaseProduct = (product) => {
    if (cart && cart.length > 0 && cart.some((e, i) => e.tempXId == product.tempXId)) {
      let newCart = cart
        .map((e, i) => {
          if (e.tempXId == product.tempXId && e.saleQty <= 1) {
            return;
          } else if (e.tempXId == product.tempXId) {
            return {
              ...e,
              saleQty: e.saleQty - 1,
            };
          } else {
            return e;
          }
        })
        .filter(Boolean);

      dispatch(updateCart(newCart));
      setText("");
      setSearchProducts([]);
    }
  };

  const handleDeleteProduct = (product) => {
    let newCart = cart.filter((e, i) => {
      return e.tempXId !== product.tempXId;
    });
    dispatch(updateCart(newCart));
    setText("");
    setSearchProducts([]);
  };

  const emailInvoice = async () => {
    let dataToSend = {
      printInvoiceData: printInvoiceData,
    };

    setEmailLoading(true);

    let data = await sessionStorage.getItem("userData");
    data = JSON.parse(data);
    let token = data;

    axios
      .post(`${Base_Uri}pdfSendToCustomer`, dataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let data = res.data;

        setEmailLoading(false);

        if (data && data.status) {
          message.info("Invoice Send Succesfully");
        }
        setPrintInvoiceData("");
        setSuccessfulTransactionModal(false);
        setSelectedOption("");
        setLessAmount(false);
        dispatch(updateExhangeProducts({}));
        dispatch(selectInvoicedCustomer(""));
        setIsVat(false);
        dispatch(updateCart([]));
      })
      .catch((error) => {
        //console.log(error, "errorrrr");
        setEmailLoading(false);
        message.info("There is a server error in email sending");
      });
  };

  const handleCloseSuccessfullTransactionModal = () => {
    setPrintInvoiceData("");
    setPdfDownloadView(false);
    setSuccessfulTransactionModal(false);
    setLessAmount(false);
    dispatch(updateExhangeProducts({}));
    dispatch(selectInvoicedCustomer(""));
    setIsVat(false);
    dispatch(updateCart([]));
    setSpecialDiscount({
      ...specialDiscount,
      selected: false,
    });
    setIsVat({
      ...isVat,
      selected: false,
    });
  };

  const handleDiscountPrice = (price, product) => {
    let newCart =
      cart &&
      cart.length > 0 &&
      cart.map((e, i) => {
        if (e.tempXId == product.tempXId) {
          return {
            ...e,
            discountPrice: price,
          };
        } else {
          return e;
        }
      });
    dispatch(updateCart(newCart));
  };

  let discount = 0;
  let totalAmount = 0;
  let vatAmount = 0;
  let costPrice = 0;
  let totalQty = 0;

  if (cart && cart.length > 0 && selectedCustomer) {
    costPrice =
      cart &&
      cart.length > 0 &&
      cart.reduce(
        (previous, current) =>
          previous + Number(current?.cost_price * current.saleQty),
        0
      );

    totalQty =
      cart &&
      cart.length > 0 &&
      cart.reduce((previous, current) => previous + Number(current.saleQty), 0);

    discount =
      cart && cart.length > 0 && selectedCustomer?.priceLevel[0]?.id === 1
        ? cart.reduce((previous, current) => {
            if (current.discountPrice < current?.trade_price) {
              return (
                previous +
                (Number(current.trade_price) * Number(current.saleQty) -
                  Number(current.discountPrice) * Number(current.saleQty))
              );
            }
            return previous;
          }, 0)
        : selectedCustomer?.priceLevel[0]?.id === 2
        ? cart.reduce((previous, current) => {
            if (current.discountPrice < current?.warehouse_price) {
              return (
                previous +
                (Number(current.warehouse_price) * Number(current.saleQty) -
                  Number(current.discountPrice) * Number(current.saleQty))
              );
            }
            return previous;
          }, 0)
        : selectedCustomer?.priceLevel[0]?.id === 4
        ? cart.reduce((previous, current) => {
            if (current.discountPrice < current?.diamond) {
              return (
                previous +
                (Number(current.diamond) * Number(current.saleQty) -
                  Number(current.discountPrice) * Number(current.saleQty))
              );
            }
            return previous;
          }, 0)
        : cart.reduce((previous, current) => {
            if (current.discountPrice < current?.retail_price) {
              return (
                previous +
                (Number(current.retail_price) * Number(current.saleQty) -
                  Number(current.discountPrice) * Number(current.saleQty))
              );
            }
            return previous;
          }, 0);

    totalAmount =
      cart &&
      cart.length > 0 &&
      selectedCustomer &&
      cart &&
      cart.length > 0 &&
      cart?.reduce((pre, current) => {
        if (
          (selectedCustomer?.priceLevel[0].id === 1
            ? current?.trade_price
            : selectedCustomer?.priceLevel[0].id === 2
            ? current?.warehouse_price
            : selectedCustomer?.priceLevel[0].id === 4
            ? current?.diamond
            : current?.retail_price) < current?.discountPrice
        ) {
          return (
            (pre || 0) +
            Number(current?.discountPrice) * Number(current?.saleQty)
          );
        } else if (selectedCustomer?.priceLevel[0]?.id == 1) {
          return (
            (pre || 0) + Number(current?.trade_price) * Number(current?.saleQty)
          );
        } else if (selectedCustomer?.priceLevel[0]?.id == 2) {
          return (
            (pre || 0) +
            Number(current?.warehouse_price) * Number(current?.saleQty)
          );
        } else if (selectedCustomer?.priceLevel[0]?.id == 4) {
          return (
            (pre || 0) + Number(current?.diamond) * Number(current?.saleQty)
          );
        } else {
          return (
            (pre || 0) +
            Number(current?.retail_price) * Number(current?.saleQty)
          );
        }
      }, 0);

    // selectedCustomer?.priceLevel[0].id === 1
    //   ? cart.reduce(
    //       (previous, current) =>
    //         previous + Number(current.saleQty) *  Number(current.trade_price),
    //       0
    //     )
    //   : selectedCustomer?.priceLevel[0]?.id === 2
    //   ? cart.reduce(
    //       (previous, current) =>
    //         previous +
    //         Number(current.saleQty) * Number(current.warehouse_price),
    //       0
    //     )
    //   : cart.reduce(
    //       (previous, current) =>
    //         previous + Number(current.saleQty) * Number(current.retail_price),
    //       0
    //     );

    totalAmount = Number(totalAmount).toFixed(2);

    if (isVat.selected) {
      vatAmount = (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100;
    } else {
      vatAmount = 0;
    }
  }

  const changeSaleQty = (qty, ind) => {
    let allproducts = [...cart];

    let productDetails =
      allproducts &&
      allproducts.length > 0 &&
      allproducts.map((e, i) => {
        if (ind == i) {
          return {
            ...e,
            saleQty: Number(qty),
          };
        } else {
          return e;
        }
      });

    dispatch(updateCart(productDetails));
  };

  const handleProceedSale = () => {
    if (!selectedCustomer) {
      message.info("Kindly add customer");
      return;
    }

    if (cart && cart.length == 0) {
      message.info("Kindly add product");
      return;
    }

    if (exchangeProducts && Object.keys(exchangeProducts).length > 0) {
      let vatAmount = isVat?.selected
        ? Number((((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100).toFixed(2)
        : 0;
      let specialDiscountAmount =
        specialDiscount?.selected && isVat?.selected
          ? Number(
              (((totalAmount - discount) * specialDiscount?.value) / 100) 
              // *
              //   (1 + vat.vatRate / 100)
            ).toFixed(2)
          : specialDiscount?.selected && !isVat?.selected
          ? Number(
              ((totalAmount - discount) * specialDiscount.value) / 100
            ).toFixed(2)
          : 0;
      let subtotal =
        Number(totalAmount) -
        Number(discount) +
        Number(vatAmount) -
        Number(exchangeProducts.subtotal) -
        Number(specialDiscountAmount);

      subtotal = Math.ceil(subtotal);

      if (Number(subtotal) < 0) {
        setOptionModal(true);
      } else if (Number(subtotal) > 0) {
        setPaymentMethodModal(true);
      } else {
        setExchangeInvoiceVisible(true);
      }
      return;
    }
    // //console.log('helos');
    // return
    setPaymentMethodModal(true);
  };

  const handleConfirmPaymentMethod = (details) => {
    if (selectedCustomer && cart && cart.length > 0) {
      setPaymentMethodDetails(details);

      if (details.credit) {
        let vatAmount = isVat?.selected
          ? (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100
          : 0;

        let subtotal = totalAmount - discount + vatAmount;

        let customerCreditBalance =
          selectedCustomer?.creditBalance + selectedCustomer?.quotationBalance;

        let totalDue = Number(details?.credit) + Number(customerCreditBalance);

        console.log(totalDue,Number(selectedCustomer?.creditLimits),customerCreditBalance)

        if (Math.abs(Number(totalDue)) > Number(selectedCustomer?.creditLimits)) {
          setOpenCreditLimitWarningModal(true);
        } else {
          setCheckOutModal(true);
          // setSpecialDiscount({
          //   ...specialDiscount,
          //   selected: false,
          // });
          // setIsVat({
          //   ...isVat,
          //   selected: false,
          // });
        }

        return;
      }

      setCheckOutModal(true);
      // setSpecialDiscount({
      //   ...specialDiscount,
      //   selected: false,
      // });
      // setIsVat({
      //   ...isVat,
      //   selected: false,
      // });
    }

    setPaymentMethodModal(false);
    
  };

  const handleConfirmOptionModal = (option, selectedDeductedBalanceOption) => {
    let selectedOption = option.filter((e, i) => e.selected);

    if (selectedOption.length == 0) {
      message.info("Kindly choose selected Option");
      return;
    }

    let choosenoption = selectedOption[0].name;

    if (choosenoption?.toLowerCase() == "on account") {
      if (
        !selectedDeductedBalanceOption ||
        selectedDeductedBalanceOption == "select"
      ) {
        message.info("kindly select credit deduct option");
        return;
      }

      let subtotal = isVat.selected
        ? (
            totalAmount -
            exchangeProducts?.subtotal -
            discount +
            ((totalAmount - discount) * vat.vatRate) / 100
          ).toFixed(2)
        : Number(totalAmount - discount - exchangeProducts?.subtotal).toFixed(
            2
          );

      subtotal = Number(subtotal).toFixed(2);

      setSelectedOption("credit");
      setDeductBalanceOption(selectedDeductedBalanceOption);
      setExchangeInvoiceVisible(true);
      return;
    }

    if (choosenoption == "Cash") {
      setSelectedOption("cash");
      setExchangeInvoiceVisible(true);
      return;
    }
    if (choosenoption == "Card") {
      setSelectedOption("card");
      setExchangeInvoiceVisible(true);
      return;
    }
    if (choosenoption == "Online") {
      setSelectedOption("online");
      setExchangeInvoiceVisible(true);
      return;
    }
    if (choosenoption == "Cheque") {
      setSelectedOption("cheque");
      setExchangeInvoiceVisible(true);
      return;
    }
  };

  const handleGoBack = () => {
    dispatch(selectInvoicedCustomer(""));
    dispatch(updateCart([]));
  };

  const closeSuccessfulTransactionModal = () => {
    dispatch(selectInvoicedCustomer(""));
    dispatch(updateCart([]));
    setLessAmount(false);
    setSelectedOption("");
    setIsVat(false);
    dispatch(updateExhangeProducts({}));
    setSuccessfulTransactionModal(false);
    setSpecialDiscount({
      ...specialDiscount,
      selected: false,
    });
    setIsVat({
      ...isVat,
      selected: false,
    });
  };

  const handleCreditDays = (event) => {
    let days = event.target.value;

    setCreditDays(days);
  };

  const handleResetProcess = () => {
    dispatch(updateCart([]));
    dispatch(updateExhangeProducts({}));
    dispatch(selectInvoicedCustomer(""));
    dispatch(updateAllReturnProductsDuplicate([]));
    setIsEdit(false)
    setSpecialDiscount({
      value:0,
      selected: false,
    });
    setIsVat({
      ...isVat,
      selected: false,
    });
    setIsVatMargin({
      selected: false,
    });
  };

  const handleShowDescription = (ind) => {
    setSearchProducts(
      searchProducts &&
        searchProducts?.length > 0 &&
        searchProducts?.map((e, i) => {
          if (ind == i) {
            return {
              ...e,
              showDescription: !e?.showDescription,
            };
          } else {
            return e;
          }
        })
    );
  };

  const openNewWindow = (path) => {
    // Open a new window with the specified path
    // window.open(`http://localhost:3000/PointOfSale`, "_blank");
    window.open(`${window.location}`, "_blank");
  };

  const handleChangeProductDetails = (product) => {
    setEditCartProductData(product);
    setOpenEditCartDetailModal(true);
  };

  const handleScan = (result) => {
    if (result) {
    }
  };

  const handleError = (error) => {
    console.error("Barcode Scanner Error:", error);
  };

  const handleVatClicked = () => {
    // if (exchangeProducts && Object.keys(exchangeProducts).length > 0) {
    //   message.info("You are not allowed to change vat option in exchange invoice");
    //   return;
    // }

    if (exchangeProducts?.subtotal&&totalAmount<1) {
      message.info("Only apply on positive ammount");
      return
    }

    setIsVat({
      ...isVat,
      selected: !isVat.selected,
    });
  };
  const handleVatMarginClicked = () => {
    // if (exchangeProducts && Object.keys(exchangeProducts).length > 0) {
    //   message.info("You are not allowed to change vat option in exchange invoice");
    //   return;
    // }

    if (exchangeProducts?.subtotal&&totalAmount<1) {
      message.info("Only apply on positive ammount");
      return
    }

    setIsVatMargin({
      selected: !isVatMargin.selected,
    });
  };

  const handleSpecialDiscount = () => {
    // if (exchangeProducts && Object.keys(exchangeProducts).length > 0) {
    //   message.info(
    //     "You are not allowed to change special discount option in exchange invoice"
    //   );
    //   return;
    // }
 if (exchangeProducts?.subtotal&&totalAmount<1) {
      message.info("Only apply on positive ammount");
      return
    }
    setSpecialDiscount({
      // ...specialDiscount,
      value: !specialDiscount.selected ? specialDiscount.value : 0,
      selected: !specialDiscount.selected,
    });
  };

  const width = window.innerWidth;

  

  const handleSelect = (invoice) => {
    setSelectedInvoiceforFilter(invoice);
    setExtraCustomerInfo(invoice?.extCustomer)
    //console.log(invoice,"invoice")
    dispatch(selectInvoicedCustomer(invoice?.customerDetails[0]));
    dispatch(updateCart(invoice.productDetails))
    if (invoice.vatAmount) {
      setIsVat({
      ...isVat,
      selected: true,
    });
    }
    if (invoice.isVatMargin) {
      setIsVatMargin({
      selected: true,
    });
    }
     if (invoice?.SDAmount) {
      setSpecialDiscount({
      // ...specialDiscount,
      value: (invoice?.SDAmount/((invoice?.total)-(invoice?.discount||0)))*100,
      selected: true,
    })
     }
setIsEdit(true)
    setModalVisible(false);
    message.success(`Selected Invoice: ${invoice.invoiceNumber}`);
  };

  //console.log(exchangeProducts,"")

  return pdfDownloadView ? (
    <Box
      style={{
        wodth: "100%",
        height: "100%",
        // border: "1px solid red",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <PDFViewer width={850} height={700} style={{ marginTop: 20 }}>
        <MyDocument />
      </PDFViewer>
      <CloseOutlinedIcon
        fontSize="large"
        style={{ color: Colors.black, marginTop: "20px", cursor: "pointer" }}
        onClick={() => handleCloseSuccessfullTransactionModal()}
      />
    </Box>
  ) : (
    <div style={{ marginBottom: 10 }}>
      {/* <BarcodeReader onError={handleError} onScan={handleScan} /> */}

      {/* <BarcodeScanner onScan={handleScan} onError={handleError} /> */}

      {/* {userData?.role == "admin" && (
        <div
          style={{
            width: "100%",
            marginBottom: 20,
            display: "flex",
            justifyContent: "center",
          }}
        >
          {/* {userData?.role == "admin" && (
            <Grid container xs={12} spacing={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  marginTop: "20px",
                }}
              >
                <Button
                  sx={{
                    border: `1px solid ${Colors.button}`,
                    marginTop: "20px",
                  }}
                  onClick={() =>
                    setShowData(
                      showData == "total"
                        ? "monthly"
                        : showData == "monthly"
                        ? "today"
                        : "total"
                    )
                  }
                >
                  {showData == "total"
                    ? "monthly"
                    : showData == "monthly"
                    ? "today"
                    : "total"}
                </Button>
              </Box>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Card
                  style={{
                    backgroundColor: "#003049",
                    width: "100%",
                    height: 150,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: 10,
                  }}
                >
                  <div style={{ textAlign: "left", marginTop: 20 }}>
                    <div
                      style={{
                        color: "white",
                        fontFamily: "Poppins",
                        fontSize: 18,
                        fontWeight: "600",
                        letterSpacing: 2,
                      }}
                    >
                      £
                      {showData == "total"
                        ? saleRevenue.total.toFixed(2)
                        : showData == "monthly"
                        ? saleRevenue.monthly.toFixed(2)
                        : saleRevenue.today.toFixed(2)}
                    </div>
                    <div
                      style={{
                        color: "white",
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "400",
                        // letterSpacing:2
                      }}
                    >
                      {showData == "total"
                        ? "Total"
                        : showData == "monthly"
                        ? "Monthly"
                        : "Today"}{" "}
                      Revenue
                    </div>
                  </div>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Card
                  style={{
                    backgroundColor: "#003049",
                    width: "100%",
                    height: 150,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: 10,
                  }}
                >
                  <img
                    src={require("../../../Images/menu.png")}
                    style={{ width: 30, height: 30 }}
                    alt=""
                  />
                  <div style={{ textAlign: "left", marginTop: 20 }}>
                    <div
                      style={{
                        color: "white",
                        fontFamily: "Poppins",
                        fontSize: 18,
                        fontWeight: "600",
                        letterSpacing: 2,
                      }}
                    >
                      {showData == "total"
                        ? totalOrder?.total
                        : showData == "monthly"
                        ? totalOrder.monthly
                        : totalOrder.today}
                    </div>
                    <div
                      style={{
                        color: "white",
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "400",
                        // letterSpacing:2
                      }}
                    >
                      {showData == "total"
                        ? "Total"
                        : showData == "monthly"
                        ? "Monthly"
                        : "Today"}{" "}
                      Orders
                    </div>
                  </div>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Card
                  style={{
                    backgroundColor: "#003049",
                    width: "100%",
                    height: 150,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: 10,
                  }}
                >
                  <img
                    src={require("../../../Images/users.png")}
                    style={{ width: 30, height: 30 }}
                    alt=""
                  />
                  <div style={{ textAlign: "left", marginTop: 20 }}>
                    <div
                      style={{
                        color: "white",
                        fontFamily: "Poppins",
                        fontSize: 18,
                        fontWeight: "600",
                        letterSpacing: 2,
                      }}
                    >
                      {showData == "total"
                        ? totalWalkins?.total
                        : showData == "monthly"
                        ? totalWalkins.monthly
                        : totalWalkins.today}
                    </div>
                    <div
                      style={{
                        color: "white",
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "400",
                        // letterSpacing:2
                      }}
                    >
                      {showData == "total"
                        ? "Total"
                        : showData == "monthly"
                        ? "Monthly"
                        : "Today"}{" "}
                      Walk-ins
                    </div>
                  </div>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Card
                  style={{
                    backgroundColor: "#003049",
                    width: "100%",
                    height: 150,
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    padding: 10,
                  }}
                >
                  <img
                    src={require("../../../Images/mouse-pointer.png")}
                    style={{ width: 30, height: 30 }}
                    alt=""
                  />
                  <div style={{ textAlign: "left", marginTop: 20 }}>
                    <div
                      style={{
                        color: "white",
                        fontFamily: "Poppins",
                        fontSize: 18,
                        fontWeight: "600",
                        letterSpacing: 2,
                      }}
                    >
                      £
                      {showData == "total" || showData == "monthly"
                        ? Number(creditBalance?.total).toFixed(2)
                        : Number(creditBalance?.today).toFixed(2)}
                    </div>
                    <div
                      style={{
                        color: "white",
                        fontFamily: "Poppins",
                        fontSize: 14,
                        fontWeight: "400",
                        // letterSpacing:2
                      }}
                    >
                      {showData == "total"
                        ? "Total"
                        : showData == "monthly"
                        ? "Total"
                        : "Today"}{" "}
                      Credit
                    </div>
                  </div>
                </Card>
              </Grid>
            </Grid>
          )} */}
      {/* </div> */}
      {/* )}  */}

      <Card
        style={{ width: "100%", marginBottom: 10, padding: 10, marginTop: 10 }}
      >
        <Box>
          <Box
            sx={{
              width: "100%",
              marginTop: { xs: "0px", sm: "10px", md: "10px" },
              border: `1px solid ${Colors.button}`,
              borderRadius: "5px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "5px 10px 5px 10px",

              backgroundColor: Colors.white,
            }}
          >
            <TextField
              variant="standard" // <== changed this
              margin="normal"
              onChange={(e) => {
                handleSearchProducts2(e.target.value);
                setProductText2(e.target.value);
              }}
              required
              value={productText2}
              fullWidth
              InputProps={{
                disableUnderline: true,
                fontSize: "12px",
              }}
              inputRef={productInputRef}
              placeholder="Search Products"
              sx={{
                width: "90%",
                fontSize: "12px",
                padding: 0,
                fontFamily: "Poppins",
                fontWeight: "bold",
                margin: 0,
              }}
            />
            <img
              src={require("../../../Images/search.png")}
              style={{ height: "20px" }}
            />
          </Box>
          <Box
            sx={{
              width: "100%",
              marginTop: { xs: "0px", sm: "10px", md: "10px" },
              border: `1px solid ${Colors.button}`,
              borderRadius: "5px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "5px 10px 5px 10px",

              backgroundColor: Colors.white,
            }}
          >
            <TextField
              variant="standard"
              margin="normal"
              onChange={async (e) => {
                handleSearchProducts(e.target.value);
                setProductText(e.target.value);
              }}
              required
              value={productText}
              fullWidth
              InputProps={{
                disableUnderline: true,
                fontSize: "12px",
                disabled: isScanning, // Disable input while scanning
              }}
              inputRef={productInputRef}
              placeholder="Search Name, Id, Phone, Sku, Category, SubCategory & Bar Code"
              sx={{
                width: "90%",
                fontSize: "12px",
                padding: 0,
                fontFamily: "Poppins",
                fontWeight: "bold",
                margin: 0,
              }}
            />

            <img
              src={require("../../../Images/search.png")}
              style={{ height: "20px" }}
            />
          </Box>
          <Box sx={{ position: "relative" }}>
            {searchProducts.length != 0 && (
              <Box sx={{ position: "absolute", top: 0, right: 0, zIndex: 100 }}>
                <IoMdClose
                  onClick={() => {
                    setSearchProducts([]);
                  }}
                  size={30}
                  color="black"
                />
              </Box>
            )}
            {searchProducts &&
              searchProducts.length > 0 &&
              searchProducts.map((e, i) => {
                return (
                  <Button
                    onClick={() => handleSelectProduct(e)}
                    sx={{
                      width: "100%",
                      // mt: 1,
                      backgroundColor: Colors.white,
                      p: "10px 10px",
                      fontFamily: "Poppins",
                      fontWeight: "bold",
                      cursor: "pointer",
                      borderRadius: 1,
                      textAlign: "left",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      border: `1px solid ${Colors.border}`,
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "Poppins",
                        textAlign: "left",
                        marginBottom: 0,
                        color: Colors.button,
                      }}
                    >
                      {e.product_name}
                      <br />
                      Available qty: {e.qty}
                    </p>

                    {/* {e?.showDescription && (
                    <p
                      style={{
                        fontFamily: "Poppins",
                        textAlign: "left",
                        marginBottom: 0,
                        fontSize: 12,
                        color: Colors.black,
                      }}
                    >
                      {e.product_description
                        ? e.product_description
                        : "No Product Description"}
                    </p>
                  )} */}

                    {/* <CustomButton
                    text={
                      e?.showDescription
                        ? "Hide Description"
                        : "Show Description"
                    }
                    onClick={() => handleShowDescription(i)}
                    style={{
                      fontFamily: "Poppins",
                      textAlign: "left",
                      marginBottom: 0,
                      fontSize: 14,
                      color: "black",
                      width: 250,
                      border: "none",
                      justifyContent: "flex-start",
                      padding: 0,
                      marginTop: "5px",
                      backgroundColor: "transparent",
                    }}
                  /> */}

                    {/* <CustomButton
                    text={"Select"}
                    style={{
                      fontFamily: "Poppins",
                      textAlign: "left",
                      marginBottom: "10px",
                      fontSize: 14,
                      // color: "black",
                      borderRadius: 2,
                      width: 250,
                      // border: "none",
                      // justifyContent: "flex-start",
                      // padding: 0,
                      marginTop: "10px",
                      // backgroundColor: "transparent",
                    }}
                  /> */}
                  </Button>
                );
              })}
          </Box>
        </Box>

        <div style={{display:"flex",alignItems:"center",gap:5}}>
          <div style={{ }}>
          <button
            onClick={() => navigate("QuickSearch")}
            style={{
              color: "#231F20",
              fontFamily: "Poppins",
              fontWeight: "600",
              fontSize: 14,
              textAlign: "left",
              marginTop: 10,
            }}
          >
            Quick Search
          </button>
        </div>
        {(userData.role_access
              ?.find((e) => e.name === "PointOfSale")
              ?.subcategory?.find(
                (e) => e.name === "EditInvoice" && e.selected
              ) || userData.role == "admin")&&<div style={{ }}>
          <button
            onClick={() => setModalVisible(true)}
            style={{
              color: "#231F20",
              fontFamily: "Poppins",
              fontWeight: "600",
              fontSize: 14,
              textAlign: "left",
              marginTop: 10,
            }}
          >
            Edit Invoice
          </button>
        </div>}
         {(userData.role_access
              ?.find((e) => e.name === "PointOfSale")
              ?.subcategory?.find(
                (e) => e.name === "openTill" && e.selected
              ) || userData.role == "admin")&&<div style={{ }}>
          <button
            onClick={handleOpenTill}
            style={{
              color: "#231F20",
              fontFamily: "Poppins",
              fontWeight: "600",
              fontSize: 14,
              textAlign: "left",
              marginTop: 10,
            }}
          >
            Open Till
          </button>
        </div>}
        </div>
      </Card>

      <Box>
        <CustomModal
          heading={`Total ${vatAmount ? "Invoice" : "Quotation"} Amount: £${
            exchangeProducts && Object.keys(exchangeProducts).length > 0
                    ? isVat.selected && !specialDiscount?.selected
                      ? (
                          totalAmount -
                          exchangeProducts?.subtotal -
                          discount +
                          ((totalAmount - discount) * vat.vatRate) / 100
                        ).toFixed(2)
                      : isVat.selected && specialDiscount?.selected
                      ? (
                          totalAmount -
                          exchangeProducts?.subtotal -
                          discount +
                          (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100 
                          -
                          (((totalAmount - discount) * specialDiscount?.value) /
                            100) 
                            // *
                            // (1 + vat.vatRate / 100)
                        ).toFixed(2)
                      : !isVat.selected && specialDiscount?.selected
                      ? (
                          totalAmount -
                          discount -
                          exchangeProducts?.subtotal -
                          ((totalAmount - discount) * specialDiscount?.value) /
                            100
                        ).toFixed(2)
                      : Number(
                          totalAmount - discount - exchangeProducts?.subtotal
                        ).toFixed(2)
                    : isVat.selected && !specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        ((totalAmount - discount) * vat.vatRate) / 100
                      ).toFixed(2)
                    : isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100 
                        -
                        (((totalAmount - discount) * specialDiscount?.value) /
                          100) 
                          // *
                          // (1 + vat.vatRate / 100)
                      ).toFixed(2)
                    : !isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount -
                        ((totalAmount - discount) * specialDiscount?.value) /
                          100
                      ).toFixed(2)
                    : Number(totalAmount - discount).toFixed(2)
            // (exchangeProducts && Object.keys(exchangeProducts).length) > 0
            //   ? Number(
            //       totalAmount -
            //         discount +
            //         vatAmount -
            //         exchangeProducts?.subtotal
            //     ).toFixed(2)
            //   : specialDiscount?.selected && isVat?.selected
            //   ? (
            //       Number(totalAmount - discount + vatAmount) -
            //       Number(
            //         (((totalAmount - discount) * specialDiscount?.value) /
            //           100) 
            //           // *
            //           // (1 + vat.vatRate / 100)
            //       )
            //     ).toFixed(2)
            //   : specialDiscount?.selected && !isVat?.selected
            //   ? (
            //       Number(totalAmount - discount + vatAmount) -
            //       Number(
            //         ((totalAmount - discount) * specialDiscount.value) / 100
            //       )
            //     ).toFixed(2)
            //   : Number(totalAmount - discount + vatAmount).toFixed(2)
          }`}
          loading={loading}
          text={
            Number(paymentMethodDetails.cash) &&
            !Number(paymentMethodDetails.card) &&
            !Number(paymentMethodDetails.credit) &&
            !Number(paymentMethodDetails.online) &&
            !Number(paymentMethodDetails.cheque)
              ? `Do you confirm that you received £${paymentMethodDetails?.cash} cash?`
              : !Number(paymentMethodDetails.cash) &&
                !Number(paymentMethodDetails.card) &&
                Number(paymentMethodDetails.credit) &&
                !Number(paymentMethodDetails.online) &&
                !Number(paymentMethodDetails.cheque)
              ? `Confirm to put £${paymentMethodDetails?.credit} on Account?`
              : !Number(paymentMethodDetails.cash) &&
                Number(paymentMethodDetails.card) &&
                !Number(paymentMethodDetails.credit) &&
                !Number(paymentMethodDetails.online) &&
                !Number(paymentMethodDetails.cheque)
              ? `Confirm to put £${paymentMethodDetails?.card} on card?`
              : !Number(paymentMethodDetails.cash) &&
                !Number(paymentMethodDetails.card) &&
                !Number(paymentMethodDetails.credit) &&
                Number(paymentMethodDetails.online) &&
                !Number(paymentMethodDetails.cheque)
              ? `Do you confirm £${paymentMethodDetails?.online} online transaction?`
              : !Number(paymentMethodDetails.cash) &&
                !Number(paymentMethodDetails.card) &&
                !Number(paymentMethodDetails.credit) &&
                !Number(paymentMethodDetails.online) &&
                Number(paymentMethodDetails.cheque)
              ? `Do you confirm that you have received £${paymentMethodDetails?.cheque} cheque?`
              : `Confirm received ${
                  Number(paymentMethodDetails?.cash)
                    ? `£${paymentMethodDetails?.cash} cash and`
                    : ""
                }   ${
                  Number(paymentMethodDetails?.card)
                    ? `£${paymentMethodDetails?.card} by card ${
                        paymentMethodDetails?.online ||
                        paymentMethodDetails?.cheque ||
                        paymentMethodDetails?.credit
                          ? "and"
                          : ""
                      }`
                    : ""
                } ${
                  Number(paymentMethodDetails?.online)
                    ? `£${paymentMethodDetails?.online} by bank transfer ${
                        paymentMethodDetails?.cheque ||
                        paymentMethodDetails?.credit
                          ? "and"
                          : ""
                      }`
                    : ""
                } ${
                  Number(paymentMethodDetails?.cheque)
                    ? `£${paymentMethodDetails?.cheque} by cheque ${
                        paymentMethodDetails?.credit ? "and" : ""
                      }  `
                    : ""
                } 
              ${
                Number(paymentMethodDetails?.credit)
                  ? `rest £${paymentMethodDetails?.credit} on Account`
                  : ""
              }
              
              `
          }
          open={checkOutModal}
          closeModal={closeCheckoutModal}
          confirm={() =>
            isEdit?handleConfirmSaleupdate():((exchangeProducts && Object.keys(exchangeProducts).length > 0)
              ? !loading && handleConfirmExchangeSale()
              : !loading && handleConfirmSale())
          }
        />

        <CustomModal
          heading={`Total ${
            vatAmount ? "Invoice" : "Quotation"
          } Amount: £${Number(
            exchangeProducts && Object.keys(exchangeProducts).length > 0
                    ? isVat.selected && !specialDiscount?.selected
                      ? (
                          totalAmount -
                          exchangeProducts?.subtotal -
                          discount +
                          ((totalAmount - discount) * vat.vatRate) / 100
                        ).toFixed(2)
                      : isVat.selected && specialDiscount?.selected
                      ? (
                          totalAmount -
                          exchangeProducts?.subtotal -
                          discount +
                          (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100 
                          -
                          (((totalAmount - discount) * specialDiscount?.value) /
                            100) 
                            // *
                            // (1 + vat.vatRate / 100)
                        ).toFixed(2)
                      : !isVat.selected && specialDiscount?.selected
                      ? (
                          totalAmount -
                          discount -
                          exchangeProducts?.subtotal -
                          ((totalAmount - discount) * specialDiscount?.value) /
                            100
                        ).toFixed(2)
                      : Number(
                          totalAmount - discount - exchangeProducts?.subtotal
                        ).toFixed(2)
                    : isVat.selected && !specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        ((totalAmount - discount) * vat.vatRate) / 100
                      ).toFixed(2)
                    : isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100 
                        -
                        (((totalAmount - discount) * specialDiscount?.value) /
                          100) 
                          // *
                          // (1 + vat.vatRate / 100)
                      ).toFixed(2)
                    : !isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount -
                        ((totalAmount - discount) * specialDiscount?.value) /
                          100
                      ).toFixed(2)
                    : Number(totalAmount - discount).toFixed(2)
          ).toFixed(2)}`}
          loading={loading}
          text={
            Number(
              Number(totalAmount) -
                Number(discount) +
                Number(vatAmount) -
                (specialDiscount?.selected?((totalAmount - discount) * specialDiscount?.value) /
                          100:0)-
                Number(exchangeProducts?.subtotal)
            ) > 0
              ? paymentMethodDetails.cash &&
                !paymentMethodDetails.card &&
                !paymentMethodDetails.credit &&
                !paymentMethodDetails.online &&
                !paymentMethodDetails.cheque
                ? `Do you confirm that you have received £${paymentMethodDetails?.cash} cash?`
                : !paymentMethodDetails.cash &&
                  !paymentMethodDetails.card &&
                  paymentMethodDetails.credit &&
                  !paymentMethodDetails.online &&
                  !paymentMethodDetails.cheque
                ? `Confirm to put £${paymentMethodDetails?.credit} on Account?`
                : !paymentMethodDetails.cash &&
                  paymentMethodDetails.card &&
                  !paymentMethodDetails.credit &&
                  !paymentMethodDetails.online &&
                  !paymentMethodDetails.cheque
                ? `Confirm to put £${paymentMethodDetails?.card} on card?`
                : !paymentMethodDetails.cash &&
                  !paymentMethodDetails.card &&
                  !paymentMethodDetails.credit &&
                  paymentMethodDetails.online &&
                  !paymentMethodDetails.cheque
                ? `Do you confirm £${paymentMethodDetails?.online} online transaction?`
                : !paymentMethodDetails.cash &&
                  !paymentMethodDetails.card &&
                  !paymentMethodDetails.credit &&
                  !paymentMethodDetails.online &&
                  paymentMethodDetails.cheque
                ? `Do you confirm that you have received £${paymentMethodDetails?.cheque} cheque?`
                : ` ${
                    paymentMethodDetails?.cash
                      ? `Do you confirm that you have received £${paymentMethodDetails?.cash} cash and`
                      : ""
                  } ${
                    paymentMethodDetails?.credit
                      ? `do you confirm to put £${
                          paymentMethodDetails?.credit
                        } on Account ${
                          paymentMethodDetails?.card ||
                          paymentMethodDetails?.online ||
                          paymentMethodDetails?.cheque
                            ? "and"
                            : ""
                        }`
                      : ""
                  }  ${
                    paymentMethodDetails?.card
                      ? `received £${paymentMethodDetails?.card} through card ${
                          (paymentMethodDetails?.online ||
                            paymentMethodDetails?.cheque) &&
                          "and"
                        }`
                      : ""
                  } ${
                    paymentMethodDetails?.online
                      ? `received £${paymentMethodDetails?.online} online ${
                          paymentMethodDetails?.cheque && "and"
                        }`
                      : ""
                  } ${
                    paymentMethodDetails?.cheque
                      ? `received £${paymentMethodDetails?.cheque} through cheque`
                      : ""
                  }   `
              : selectedOption?.toLowerCase() == "cash"
              ? "Are you sure you want to refund cash"
              : selectedOption?.toLowerCase() == "card"
              ? "Are you sure you want to refund card"
              : selectedOption?.toLowerCase() == "online"
              ? "Are you sure you want to refund online"
              : selectedOption?.toLowerCase() == "cheque"
              ? "Are you sure you want to refund cheque"
              : selectedOption?.toLowerCase() == "credit"
              ? "Are you sure you want to Credit Note on Account?"
              : "Are you sure you want to make this exchange invoice"
          }
          open={exchangeInvoiceVisible}
          closeModal={() => setExchangeInvoiceVisible(false)}
          confirm={handleConfirmExchangeSale}
        />

        <PaymentMethodModal
          heading={`Select Payment Method`}
          loading={loading}
          // text={"Can you confirm that you have received this amount?"}
          open={paymentMethodModal}
          subtotal={
            exchangeProducts && Object.keys(exchangeProducts).length > 0
                    ? isVat.selected && !specialDiscount?.selected
                      ? (
                          totalAmount -
                          exchangeProducts?.subtotal -
                          discount +
                          ((totalAmount - discount) * vat.vatRate) / 100
                        )
                      : isVat.selected && specialDiscount?.selected
                      ? (
                          totalAmount -
                          exchangeProducts?.subtotal -
                          discount +
                          (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100 
                          -
                          (((totalAmount - discount) * specialDiscount?.value) /
                            100) 
                            // *
                            // (1 + vat.vatRate / 100)
                        )
                      : !isVat.selected && specialDiscount?.selected
                      ? (
                          totalAmount -
                          discount -
                          exchangeProducts?.subtotal -
                          ((totalAmount - discount) * specialDiscount?.value) /
                            100
                        )
                      : Number(
                          totalAmount - discount - exchangeProducts?.subtotal
                        )
                    : isVat.selected && !specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        ((totalAmount - discount) * vat.vatRate) / 100
                      )
                    : isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100 
                        -
                        (((totalAmount - discount) * specialDiscount?.value) /
                          100) 
                          // *
                          // (1 + vat.vatRate / 100)
                      )
                    : !isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount -
                        ((totalAmount - discount) * specialDiscount?.value) /
                          100
                      )
                    : Number(totalAmount - discount)
            // exchangeProducts && Object?.keys(exchangeProducts)?.length > 0
            //   ? specialDiscount?.selected && isVat?.selected
            //     ? (
            //               totalAmount -
            //               exchangeProducts?.subtotal -
            //               discount +
            //               (((totalAmount-exchangeProducts?.subtotal - discount)- (((totalAmount-exchangeProducts?.subtotal - discount) * specialDiscount?.value) /
            //                 100) ) * vat.vatRate) / 100 
            //               -
            //               (((totalAmount-exchangeProducts?.subtotal - discount) * specialDiscount?.value) /
            //                 100) 
            //                 // *
            //                 // (1 + vat.vatRate / 100)
            //             )
            //     : specialDiscount?.selected && !isVat?.selected
            //     ? Number(totalAmount - discount + vatAmount) -
            //       Number(exchangeProducts?.subtotal) -
            //       Number(
            //         ((totalAmount - discount) * specialDiscount.value) / 100
            //       )
            //     : Number(totalAmount - discount + vatAmount) -
            //       Number(exchangeProducts?.subtotal)
            //   : specialDiscount?.selected && isVat?.selected
            //   ? Number(totalAmount - discount + vatAmount) -
            //     Number(
            //       (((totalAmount - discount) * specialDiscount?.value) / 100)
            //       // *
            //       //   (1 + vat.vatRate / 100)
            //     )
            //   : specialDiscount?.selected && !isVat?.selected
            //   ? Number(totalAmount - discount + vatAmount) -
            //     Number(((totalAmount - discount) * specialDiscount.value) / 100)
            //   : Number(totalAmount - discount + vatAmount)
          }
          closeModal={() => setPaymentMethodModal(false)}
          confirm={handleConfirmPaymentMethod}
        />

        <OptionModal
          heading={`Select Refund Option`}
          loading={loading}
          // text={"Can you confirm that you have received this amount?"}
          open={optionModal}
          closeModal={() => setOptionModal(false)}
          confirm={handleConfirmOptionModal}
        />

        {creditModal && (
          <CustomModal
            heading={`Subtotal: £${((exchangeProducts &&
              Object.keys(exchangeProducts).length) > 0
              ? totalAmount - discount + vatAmount - exchangeProducts?.subtotal
              : totalAmount - discount + vatAmount
            ).toFixed(2)}`}
            loading={loading}
            credit={true}
            onChange={handleCreditDays}
            text={"Are you sure you want to make this transaction on credit?"}
            open={creditModal}
            closeModal={() => setCreditModal(false)}
            confirm={() =>
             isEdit?handleConfirmSaleupdate(): exchangeProducts && Object.keys(exchangeProducts).length > 0
                ? !loading && handleConfirmExchangeSale()
                : !loading && handleConfirmSale()
            }
          />
        )}

        {successfulTransactionModal && (
          <CustomModal
            heading={`Transaction Successful`}
            loading={loading}
            emailbutton={true}
            emailInvoice={emailInvoice}
            emailLoading={emailLoading}
            text={"Do You want to print the invoice?"}
            open={successfulTransactionModal}
            closeModal={() => closeSuccessfulTransactionModal()}
            confirm={handlePrint}
            // containerStyle={{zIndex:1000000000}}
          />
        )}

        <CustomModal2
          open={creditAccountModal}
          closeModal={() => setCreditAccountModal(false)}
        />
        <OnlineTransactionModal
          heading={"Online Transaction"}
          text={"Reference ID:"}
          onChange={(e) => setOnlineReferenceId(e.target.value)}
          open={onlineModalVisible}
          closeModal={() => setOnlineModalVisible(false)}
          loading={loading}
          buttonStyle2={{ width: "200px", fontSize: "14px", mt: 2 }}
          buttonText="Received Amount"
          confirm={() =>
            isEdit?handleConfirmSaleupdate():exchangeProducts && Object.keys(exchangeProducts).length > 0
              ? !loading && handleConfirmExchangeSale()
              : !loading && handleConfirmSale()
          }
        />

        <OnlineTransactionModal
          heading={"Card Transaction"}
          text={"Transaction ID:"}
          onChange={(e) => setCardTransactionId(e.target.value)}
          open={cardModalVisible}
          closeModal={() => setCardModalVisible(false)}
          loading={loading}
          buttonStyle2={{ width: "200px", fontSize: "14px", mt: 2 }}
          buttonText="Confirm"
          confirm={() =>
            isEdit?handleConfirmSaleupdate(): exchangeProducts && Object.keys(exchangeProducts).length > 0
              ? !loading && handleConfirmExchangeSale()
              : !loading && handleConfirmSale()
          }
        />

        <ChequeModal
          heading={"Cheque"}
          text={"Cheque No:"}
          text1={"Bank Name:"}
          text2={"Clear Date:"}
          loading={loading}
          onChange={(e) =>
            setChequeDetails({ ...chequeDetails, chequeNo: e.target.value })
          }
          onChange1={(e) =>
            setChequeDetails({ ...chequeDetails, bankName: e.target.value })
          }
          onChangeDay={(e) =>
            setChequeDetails({ ...chequeDetails, day: e.target.value })
          }
          onChangeMonth={(e) =>
            setChequeDetails({ ...chequeDetails, month: e.target.value })
          }
          onChangeYear={(e) =>
            setChequeDetails({ ...chequeDetails, year: e.target.value })
          }
          open={chequeModalVisible}
          closeModal={() => setChequeModalVisible(false)}
          buttonStyle2={{ width: "200px", fontSize: "14px", mt: 2 }}
          buttonText="Confirm Purchase"
          confirm={() =>
           isEdit?handleConfirmSaleupdate(): exchangeProducts && Object.keys(exchangeProducts).length > 0
              ? !loading && handleConfirmExchangeSale()
              : !loading && handleConfirmSale()
          }
        />
         <Box sx={{ marginTop: "0px" }}>
            <Grid
              container
              xs={12}
              sm={12}
              md={12}
              sx={{
                backgroundColor: Colors.black,
                padding: "10px 0px 10px 0px",
                borderTopLeftRadius:5,
                borderTopRightRadius:5
              }}
            >
              <Grid item xl={0.8} lg={0.8} md={1} sm={0.8} xs={0.5}>
                <Typography
                  sx={{
                    color: Colors.white,
                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: {
                      lg: "12px",
                      md: "10px",
                      sm: "8px",
                      xs: "6px",
                    },
                  }}
                >
                  Item
                </Typography>
              </Grid>

              <Grid item xl={4.2} lg={4.2} md={4.5} sm={4.2} xs={3.5}>
                <Typography
                  sx={{
                    color: Colors.white,
                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: {
                      lg: "12px",
                      md: "10px",
                      sm: "8px",
                      xs: "6px",
                    },
                    textAlign: "left",
                  }}
                >
                  Product Description
                </Typography>
              </Grid>

              <Grid item xl={2.5} lg={3} md={3} sm={3} xs={3.5}>
                <Typography
                  sx={{
                    color: Colors.white,
                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: {
                      lg: "12px",
                      md: "10px",
                      sm: "8px",
                      xs: "6px",
                    },
                    textAlign: "left",
                  }}
                >
                  Quantity
                </Typography>
              </Grid>

              {/* <Grid item xl={1.5} lg={2} md={1.5} sm={2} xs={1.5}>
                  <Typography
                    sx={{
                      color: Colors.white,
                      fontFamily: "Poppins",
                      fontWeight: "500",
                      fontSize: {
                        lg: "16px",
                        md: "12px",
                        sm: "10px",
                        xs: "8px",
                      },
                      textAlign: "left",
                    }}
                  >
                    Warranty
                  </Typography>
                </Grid> */}
              <Grid item xl={1.5} lg={1} md={1} sm={1.5} xs={1.5}>
                <Typography
                  sx={{
                    color: Colors.white,
                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: {
                      lg: "12px",
                      md: "10px",
                      sm: "8px",
                      xs: "6px",
                    },
                    textAlign: { md: "center", lg: "left" },
                  }}
                >
                  Price(£)
                </Typography>
              </Grid>

              <Grid item xl={1.5} lg={1} md={1} sm={1.5} xs={1.5}>
                <Typography
                  sx={{
                    color: Colors.white,
                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: {
                      lg: "12px",
                      md: "10px",
                      sm: "8px",
                      xs: "6px",
                    },
                    textAlign: { md: "center", lg: "left" },
                  }}
                >
                  Total(£)
                </Typography>
              </Grid>
              <Grid item xl={1.5} lg={1} md={2} sm={2} xs={2.5}>
                <Typography
                  sx={{
                    color: Colors.white,

                    fontFamily: "Poppins",
                    fontWeight: "500",
                    fontSize: {
                      lg: "12px",
                      md: "10px",
                      sm: "8px",
                      xs: "6px",
                    },
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Grid>
            </Grid>
          </Box>
          
        <Box
          sx={{
            backgroundColor: Colors.white,
            border: `1px solid ${Colors.border}`,
            width: "100%",
            maxHeight: window.innerHeight - 450,
            minHeight: "200px",
            overflow: "auto",
            borderBottomLeftRadius: "5px",
            borderBottomRightRadius: "5px",
            boxSizing: "border-box",
            padding: "0px 0px 0px 0px",
            position:"relative",
          }}

        >
          

          <Box sx={{ marginTop: "0px", backgroundColor: Colors.white }}>
            {cart && cart?.length > 0 ? (
              cart?.map((e, i) => {
                return (
                  <Grid
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    sx={{
                      backgroundColor:
                        (e?.discountPrice
                          ? Number(e?.discountPrice)
                          : selectedCustomer &&
                            selectedCustomer?.priceLevel[0]?.id == 1
                          ? Number(e?.trade_price).toFixed(2)
                          : selectedCustomer &&
                            selectedCustomer?.priceLevel[0]?.id == 2
                          ? Number(e?.warehouse_price).toFixed(2)
                          : selectedCustomer &&
                            selectedCustomer?.priceLevel[0]?.id == 4
                          ? Number(e?.diamond).toFixed(2)
                          : Number(e?.retail_price)) == 0
                          ? "rgba(245, 112, 112, 0.2)"
                          : e?.tempXId == highlightedProduct
                          ? "rgba(15,100,179,0.2)"
                          : Colors.white,
                      padding: "2px 0px 0px 0px",
                      borderBottom: `1px solid ${Colors.border}`,
                    }}
                    ref={(el) => (productRefs.current[e?.barcode] = el)}
                    key={i}
                  >
                    <Grid
                      item
                      xl={0.8}
                      lg={0.8}
                      md={1}
                      sm={0.8}
                      xs={0.5}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: Colors.text,
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: {
                            lg: "12px",
                            md: "10px",
                            sm: "8px",
                            xs: "6px",
                          },
                        }}
                      >
                        {i + 1}
                      </Typography>
                    </Grid>

                    <Grid
                      item
                      xl={4.2}
                      lg={4.2}
                      md={4.5}
                      sm={4.2}
                      xs={3.5}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "background: #000",
                          fontFamily: "Poppins",
                          fontWeight: "600",
                          fontSize: {
                            lg: "12px",
                            md: "10px",
                            sm: "8px",
                            xs: "6px",
                          },
                          textAlign: "left",
                        }}
                      >
                        {e?.productName}
                        <br />
                        {typeof e?.IMEI == "object" ? (
                          <View>
                            {e?.IMEI?.map((it, ind) => {
                              return (
                                <View>
                                  <Text
                                    style={{
                                      fontFamily: "Poppins",
                                      fontSize: 12,
                                    }}
                                  >
                                    {it}
                                    <br />
                                  </Text>
                                </View>
                              );
                            })}
                          </View>
                        ) : (
                          <Text style={{ fontFamily: "Poppins", fontSize: 12 }}>
                            {e?.IMEI}
                          </Text>
                        )}
                      </Typography>

                      {/* <Typography
                            sx={{
                              color: "background: #939598",
                              fontFamily: "Poppins",
                              fontWeight: "500",
                              fontSize: {
                                lg: "12px",
                                md: "10px",
                                sm: "8px",
                                xs: "6px",
                              },
                              textAlign: "left",
                            }}
                          >
                            Category: {e?.category}
                          </Typography> */}
                    </Grid>

                    <Grid
                      item
                      xl={2.5}
                      lg={3}
                      md={3.5}
                      sm={3}
                      xs={3.5}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          // justifyContent: "space-between",
                          width: "100%",
                          //   border: "1px solid red",
                        }}
                      >
                        <button
                          onClick={() => handleDecreaseProduct(e)}
                          style={{
                            width: width < 600 ? "15px" : "20px",
                            padding: "0px 0px 0px 0px",
                            height: width < 600 ? "15px" : "20px",
                            borderRadius: "5px",
                            marginRight: "10px",
                            backgroundColor: Colors.white,
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            border: `1px solid ${Colors?.border}`,
                          }}
                        >
                          -
                        </button>

                        <TextField
                          variant="standard"
                          margin="none"
                          required
                          onChange={(e) => changeSaleQty(e.target.value, i)}
                          value={e?.saleQty}
                          fullWidth
                          inputProps={{
                            disableUnderline: true,
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: Colors.red,
                            style: {
                              textAlign: "center",
                              fontSize: "12px",
                              color: Colors.red,
                              fontWeight: "bold",
                            },
                          }}
                          placeholder="Price"
                          style={{
                            width: width < 600 ? "15px" : "20px",
                            height: width < 600 ? "15px" : "20px",
                            padding: "0px 0px 0px 0px",

                            borderRadius: "5px",
                            color: Colors.red,
                            backgroundColor: Colors.white,
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            margin: 0,
                            marginRight: 10,
                            // border: `1px solid ${Colors?.button}`,
                          }}
                        />

                        <button
                          style={{
                            width: width < 600 ? "15px" : "20px",
                            height: width < 600 ? "15px" : "20px",
                            padding: "0px 0px 0px 0px",
                            borderRadius: "5px",
                            color: Colors.button,
                            backgroundColor: Colors.white,
                            fontFamily: "Poppins",
                            fontWeight: "bold",
                            border: `1px solid ${Colors?.button}`,
                          }}
                          onClick={() => handleIncreaseProduct(e)}
                        >
                          +
                        </button>
                      </Box>
                    </Grid>
                    <Grid
                      item
                      xl={1.5}
                      lg={1.5}
                      md={1}
                      sm={1}
                      xs={1}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <TextField
                        variant="standard" // <== changed this
                        margin="normal"
                        value={
                          e?.discountPrice
                            ? Number(e?.discountPrice)
                            : selectedCustomer &&
                              selectedCustomer?.priceLevel[0]?.id == 1
                            ? Number(e?.trade_price).toFixed(2)
                            : selectedCustomer &&
                              selectedCustomer?.priceLevel[0]?.id == 2
                            ? Number(e?.warehouse_price).toFixed(2)
                            : selectedCustomer &&
                              selectedCustomer?.priceLevel[0]?.id == 4
                            ? Number(e?.diamond).toFixed(2)
                            : Number(e?.retail_price).toFixed(2)
                        }
                        onChange={(text) =>
                          userData?.role_access?.some(
                            (e, i) =>
                              e.name.toLowerCase() == "showcostprice" &&
                              e?.selected
                          ) || userData?.role == "admin"
                            ? handleDiscountPrice(text.target.value, e)
                            : ""
                        }
                        required
                        fullWidth
                        InputProps={{
                          // startAdornment: <AccountCircle />, // <== adjusted this
                          disableUnderline: true,
                          fontSize: "12px",

                          // <== added this
                          // fontSize: "2px"
                        }}
                        placeholder="Search Product/Customer/Invoice"
                        sx={{
                          width: "90%",
                          fontSize: "12px",
                          padding: 0,
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          margin: 0,
                        }}
                      />
                    </Grid>

                    <Grid
                      item
                      xl={1.5}
                      lg={1.5}
                      md={1}
                      sm={1}
                      xs={1}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <TextField
                        variant="standard" // <== changed this
                        margin="normal"
                        value={(
                          Number(
                            e?.discountPrice
                              ? Number(e?.discountPrice)
                              : selectedCustomer &&
                                selectedCustomer?.priceLevel[0]?.id == 1
                              ? Number(e?.trade_price)
                              : selectedCustomer &&
                                selectedCustomer?.priceLevel[0]?.id == 2
                              ? Number(e?.warehouse_price)
                              : selectedCustomer &&
                                selectedCustomer?.priceLevel[0]?.id == 4
                              ? Number(e?.diamond)
                              : Number(e?.retail_price)
                          ) * Number(e?.saleQty)
                        ).toFixed(2)}
                        // onChange={(text) =>
                        //   handleDiscountPrice(text.target.value, e)
                        // }
                        required
                        fullWidth
                        InputProps={{
                          // startAdornment: <AccountCircle />, // <== adjusted this
                          disableUnderline: true,
                          fontSize: "12px",

                          // <== added this
                          // fontSize: "2px"
                        }}
                        placeholder="Search Product/Customer/Invoice"
                        sx={{
                          width: "90%",
                          fontSize: "12px",
                          padding: 0,
                          fontFamily: "Poppins",
                          fontWeight: "bold",
                          margin: 0,
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xl={1.5}
                      lg={1}
                      md={2}
                      sm={2}
                      xs={2.5}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          width:
                            !userData?.role_access?.some(
                              (e, i) =>
                                e.name.toLowerCase() == "showcostprice" &&
                                e?.selected
                            ) && !userData?.role == "admin"
                              ? "100%"
                              : "20%",

                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                        onClick={() => handleDeleteProduct(e)}
                      >
                        <img
                          src={require("../../../Images/delete.png")}
                          style={{ height: "15px" }}
                        />
                      </Box>
                      {(userData?.role_access?.some(
                        (e, i) =>
                          e.name.toLowerCase() == "showcostprice" && e?.selected
                      ) ||
                        userData?.role == "admin") && (
                        <Box>
                          {refHover?.hover && refHover.ind == i && (
                            <Typography style={{ fontSize: "10px" }}>
                              {(e?.cost_price||0).toFixed(2)}.000
                            </Typography>
                          )}

                          <Button
                            // onMouseEnter={() =>
                            //   setRefHover({
                            //     hover: true,
                            //     ind: i,
                            //   })
                            // }
                            // onMouseLeave={() =>
                            //   setRefHover({
                            //     hover: false,
                            //   })
                            // }

                            onClick={() => {
                              setRefHover({
                                hover: !refHover?.hover,
                                ind: i,
                              });
                            }}
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              padding: 0,
                              marginLeft: 1,
                              // border: `1px solid ${Colors.border}`,
                              borderRadius: 1,
                            }}
                          >
                            Ref
                          </Button>

                          {/* <BasicSelect
                          value={e?.status}
                          status="Select"
                          id={productStatus}
                          width={{ lg: "80%", md: "60%", xs: "50%" }}
                          onChange={(j) => changeProductStatus(j, i)}
                        /> */}
                        </Box>
                      )}

                      <Button
                        // onMouseEnter={() =>
                        //   setRefHover({
                        //     hover: true,
                        //     ind: i,
                        //   })
                        // }
                        // onMouseLeave={() =>
                        //   setRefHover({
                        //     hover: false,
                        //   })
                        // }

                        onClick={() => {
                          handleChangeProductDetails(e);
                          setIsEditOpen(true)
                        }}
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: "12px",
                          padding: 0,
                          marginLeft: 1,
                          // border: `1px solid ${Colors.border}`,
                          borderRadius: 1,
                        }}
                      >
                        Edit
                      </Button>
                    </Grid>
                  </Grid>
                );
              })
            ) : (
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 10,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "24px",
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                  }}
                >
                  No Product Added
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            backgroundColor: Colors.white,
            marginTop: "10px",
            padding: "20px",
            borderRadius: "5px",
          }}
        >
          <Grid container xs={12} sm={12} md={12}>
            <Grid item xs={12} sm={12} md={7}>
              {!(
                exchangeProducts &&
                Object.keys(exchangeProducts).length > 0 &&
                exchangeProducts?.productDetails
              ) && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderBottom: `1px solid ${Colors.border}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    Total Products Sale
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    {cart?.length}
                  </Typography>
                </Box>
              )}

              {/* {exchangeProducts &&
                Object.keys(exchangeProducts).length > 0 &&
                exchangeProducts?.productDetails && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: `1px solid ${Colors.border}`,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      Total Products Return
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.red,
                      }}
                    >
                      -{exchangeProducts?.totalItems}
                    </Typography>
                  </Box>
                )} */}

              {/* {exchangeProducts &&
                Object.keys(exchangeProducts).length > 0 &&
                exchangeProducts?.productDetails && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: `1px solid ${Colors.border}`,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      Total Products
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      {cart?.length - exchangeProducts?.totalItems}
                    </Typography>
                  </Box>
                )} */}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderBottom: `1px solid ${Colors.border}`,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: Colors.black,
                  }}
                >
                  Total Quantity Sale
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: Colors.black,
                  }}
                >
                  {cart && cart.length > 0
                    ? cart.reduce(
                        (previous, current) =>
                          previous + Number(current.saleQty),
                        0
                      )
                    : 0}
                </Typography>
              </Box>

              {exchangeProducts &&
                Object.keys(exchangeProducts).length > 0 &&
                exchangeProducts?.productDetails && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: `1px solid ${Colors.border}`,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      Total Quantity Return
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.red,
                      }}
                    >
                      -{exchangeProducts?.totalQty}
                    </Typography>
                  </Box>
                )}

              {/* {exchangeProducts &&
                Object.keys(exchangeProducts).length > 0 &&
                exchangeProducts?.productDetails && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: `1px solid ${Colors.border}`,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      Total Quantity
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      {(cart && cart.length > 0
                        ? cart.reduce(
                            (previous, current) =>
                              previous + Number(current.saleQty),
                            0
                          )
                        : 0) - exchangeProducts?.totalQty}
                    </Typography>
                  </Box>
                )} */}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderBottom: `1px solid ${Colors.border}`,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: Colors.black,
                  }}
                >
                  {exchangeProducts && Object.keys(exchangeProducts).length > 0
                    ? "Total Sale Amount"
                    : "Subtotal"}
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: Colors.black,
                  }}
                >
                  £{Number(totalAmount).toFixed(2)}
                </Typography>
              </Box>

              

              {/* {exchangeProducts &&
                Object.keys(exchangeProducts).length > 0 &&
                exchangeProducts?.productDetails && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: `1px solid ${Colors.border}`,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      Subtotal
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      £
                      {Number(
                        Number(totalAmount) 
                      ).toFixed(2)}
                    </Typography>
                  </Box>
                )} */}

              {selectedCustomer?.showDiscount ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderBottom: `1px solid ${Colors.border}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    Discount
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    £{Number(discount).toFixed(2)}
                  </Typography>
                </Box>
              ) : (
                <></>
              )}

              {isVat?.selected && discount ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderBottom: `1px solid ${Colors.border}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    Subtotal after discount
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    £
                    {exchangeProducts && exchangeProducts?.subtotal
                      ? Number(
                          totalAmount - discount
                        ).toFixed(2)
                      : Number(totalAmount - discount).toFixed(2)}
                  </Typography>
                </Box>
              ) : (
                ""
              )}
{specialDiscount?.selected && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderBottom: `1px solid ${Colors.border}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    Special Discount
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    - £
                    {
                    // isVat?.selected
                    //   ? Number(
                    //       (((totalAmount - discount) * specialDiscount?.value) /
                    //         100) *
                    //         (1 + vat.vatRate / 100)
                    //     ).toFixed(2)
                    //   : 
                    ( !totalAmount&&exchangeProducts?.SDAmount)?exchangeProducts?.SDAmount: exchangeProducts?.subtotal?(Number(
                          ((totalAmount- discount) * specialDiscount?.value) /
                            100
                        )).toFixed(2):(Number(
                          ((totalAmount - discount) * specialDiscount?.value) /
                            100
                        )).toFixed(2)}
                  </Typography>
                </Box>
              )}
              {(specialDiscount?.selected&&isVat?.selected) && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderBottom: `1px solid ${Colors.border}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.button,
                    }}
                  >
                   {(exchangeProducts && Object.keys(exchangeProducts).length > 0)?"Subtotal":"Total"}
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.button,
                    }}
                  >
                     £
                   {exchangeProducts && Object.keys(exchangeProducts).length > 0
                    ? (
                          totalAmount -
                          discount -
                          // exchangeProducts?.subtotal -
                          ((totalAmount - discount) * specialDiscount?.value) /
                            100
                        ).toFixed(2):(
                        totalAmount -
                        discount -
                        ((totalAmount - discount) * specialDiscount?.value) /
                          100
                      ).toFixed(2)}
                  </Typography>
                </Box>
              )}
              {isVat?.selected && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px",
                    borderBottom: `1px solid ${Colors.border}`,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    VAT
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: Colors.black,
                    }}
                  >
                    £
                    {(!totalAmount&&exchangeProducts?.vatAmount)?exchangeProducts?.vatAmount:exchangeProducts?.subtotal?(Number(
                      (((totalAmount - discount)-(((totalAmount - discount) * specialDiscount?.value) /
                            100)) * vat.vatRate) / 100
                    )).toFixed(2):(Number(
                      (((totalAmount - discount)-(((totalAmount - discount) * specialDiscount?.value) /
                            100)) * vat.vatRate) / 100
                    )).toFixed(2)}
                    {/* {exchangeProducts?.vatAmount?exchangeProducts?.vatAmount:Number(
                      ((totalAmount - discount) * vat.vatRate) / 100
                    ).toFixed(2)} */}
                  </Typography>
                </Box>
              )}
              {exchangeProducts &&
                Object.keys(exchangeProducts).length > 0 &&
                exchangeProducts?.productDetails && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: `1px solid ${Colors.border}`,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      Total
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: Colors.red,
                      }}
                    >
                      { isVat.selected && !specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        ((totalAmount - discount) * vat.vatRate) / 100
                      ).toFixed(2)
                    : isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100 
                        -
                        (((totalAmount - discount) * specialDiscount?.value) /
                          100) 
                          // *
                          // (1 + vat.vatRate / 100)
                      ).toFixed(2)
                    : !isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount -
                        ((totalAmount - discount) * specialDiscount?.value) /
                          100
                      ).toFixed(2)
                    : Number(totalAmount - discount).toFixed(2)}
                    </Typography>
                  </Box>
                )}
{exchangeProducts &&
                Object.keys(exchangeProducts).length > 0 &&
                exchangeProducts?.productDetails && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "10px",
                      borderBottom: `1px solid ${Colors.border}`,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: Colors.black,
                      }}
                    >
                      Total Return Amount
                    </Typography>

                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: Colors.red,
                      }}
                    >
                      £-{Number(exchangeProducts?.subtotal).toFixed(2)}
                    </Typography>
                  </Box>
                )}
              

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  borderBottom: `1px solid ${Colors.border}`,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: Colors.button,
                  }}
                >
                  Grand Total
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: Colors.button,
                  }}
                >
                  £
                  {exchangeProducts && Object.keys(exchangeProducts).length > 0
                    ? isVat.selected && !specialDiscount?.selected
                      ? (
                          totalAmount -
                          exchangeProducts?.subtotal -
                          discount +
                          ((totalAmount - discount) * vat.vatRate) / 100
                        ).toFixed(2)
                      : isVat.selected && specialDiscount?.selected
                      ? (
                          totalAmount -
                          exchangeProducts?.subtotal -
                          discount +
                          (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100 
                          -
                          (((totalAmount - discount) * specialDiscount?.value) /
                            100) 
                            // *
                            // (1 + vat.vatRate / 100)
                        ).toFixed(2)
                      : !isVat.selected && specialDiscount?.selected
                      ? (
                          totalAmount -
                          discount -
                          exchangeProducts?.subtotal -
                          ((totalAmount - discount) * specialDiscount?.value) /
                            100
                        ).toFixed(2)
                      : Number(
                          totalAmount - discount - exchangeProducts?.subtotal
                        ).toFixed(2)
                    : isVat.selected && !specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        ((totalAmount - discount) * vat.vatRate) / 100
                      ).toFixed(2)
                    : isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount +
                        (((totalAmount - discount)- (((totalAmount - discount) * specialDiscount?.value) /
                            100) ) * vat.vatRate) / 100 
                        -
                        (((totalAmount - discount) * specialDiscount?.value) /
                          100) 
                          // *
                          // (1 + vat.vatRate / 100)
                      ).toFixed(2)
                    : !isVat.selected && specialDiscount?.selected
                    ? (
                        totalAmount -
                        discount -
                        ((totalAmount - discount) * specialDiscount?.value) /
                          100
                      ).toFixed(2)
                    : Number(totalAmount - discount).toFixed(2)}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} md={5}>
              <Button
                onClick={() => openNewWindow()}
                sx={{
                  backgroundColor: Colors.green,
                  color: Colors.white,
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  padding: "5px",
                  borderRadius: "20px",
                  border: `1px solid ${Colors.button}`,
                  width: "150px",
                  "&:hover": {
                    color: Colors.button, // Set your desired hover color
                  },
                }}
              >
                New Invoice
              </Button>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  // justifyContent: "center",
                  alignItems: "center",
                  height:
                    exchangeProducts && Object.keys(exchangeProducts).length > 0
                      ? "400px"
                      : "280px",

                  width: "100%",
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    marginBottom: 2,
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      mr: 1,
                    }}
                  >
                    include Vat
                  </Typography>

                  <Checkbox
                    data={isVat}
                    color={Colors.white}
                    style={{
                      backgroundColor: isVat.selected
                        ? Colors.button
                        : Colors.white,
                    }}
                    onClick={() => handleVatClicked()}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    marginBottom: 2,
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      mr: 1,
                    }}
                  >
                    Vat Margin
                  </Typography>

                  <Checkbox
                    data={isVatMargin}
                    color={Colors.white}
                    style={{
                      backgroundColor: isVatMargin.selected
                        ? Colors.button
                        : Colors.white,
                    }}
                    onClick={() => handleVatMarginClicked()}
                  />
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    marginBottom: 2,
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "14px",
                      fontWeight: "bold",
                      mr: 1,
                    }}
                  >
                    Special Discount
                  </Typography>

                  <Checkbox
                    data={specialDiscount}
                    color={Colors.white}
                    style={{
                      backgroundColor: specialDiscount.selected
                        ? Colors.button
                        : Colors.white,
                    }}
                    onClick={() => handleSpecialDiscount()}
                  />
                </Box>
                {specialDiscount.selected && (
                  <TextField
                    variant="standard" // <== changed this
                    margin="normal"
                    onChange={(e) => {
                      const value = e.target.value.replace("%", "");
                      if (!isNaN(value) && value >= 0 && value <= 100) {
                        setSpecialDiscount({
                          ...specialDiscount,
                          value: value,
                        });
                      }
                    }}
                    required
                    value={`${specialDiscount?.value}%`}
                    fullWidth
                    InputProps={{
                      disableUnderline: true,
                      sx: {
                        textAlign: "center", // Center-aligns the text
                        fontSize: "12px",
                      },
                    }}
                    // inputRef={productInputRef}
                    placeholder="Enter discount"
                    sx={{
                      backgroundColor: Colors.white,
                      color: Colors.button,
                      fontFamily: "Poppins",
                      paddingLeft: "5px",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "20px",
                      border: `1px solid ${Colors.button}`,
                      width: "150px",
                      "& .MuiInputBase-input": {
                        textAlign: "center", // Center-aligns the text
                      },
                      "&:hover": {
                        color: Colors.button, // Set your desired hover color
                      },
                    }}
                  />
                )}

                <Popconfirm
                  onConfirm={handleResetProcess}
                  title="Are you sure?"
                  description="Reset changes are you sure?"
                >
                  <Button
                    // onClick={() => handleResetProcess()}
                    sx={{
                      backgroundColor: Colors.white,
                      color: Colors.button,
                      fontFamily: "Poppins",
                      fontSize: "12px",
                      padding: "5px",
                      borderRadius: "20px",
                      border: `1px solid ${Colors.button}`,
                      width: "150px",
                      "&:hover": {
                        color: Colors.button, // Set your desired hover color
                      },
                    }}
                  >
                    Reset
                  </Button>
                </Popconfirm>

                <Button
                  onClick={() => handleProceedSale()}
                  sx={{
                    backgroundColor: Colors.button,
                    color: Colors.white,
                    marginTop: "15px",
                    fontFamily: "Poppins",
                    fontSize: "12px",
                    padding: "5px",
                    borderRadius: "20px",
                    border: `1px solid ${Colors.button}`,
                    width: "150px",
                    "&:hover": {
                      color: Colors.button, // Set your desired hover color
                    },
                  }}
                >
                  {isEdit?"Edit Inovice":"Proceed to pay"}
                </Button>
                {exchangeProducts &&
                  Object.keys(exchangeProducts).length > 0 && (
                    <Popconfirm
                      title="Are you sure you want to go back?"
                      onConfirm={() => {
                        // setSelectedInvoice({
                        //   ...exchangeProducts,
                        //   customerDetails: [exchangeProducts.customerDetails],
                        // });
                        // updateAllReturnProducts({...exchangeProducts,customerDetails:[exchangeProducts.customerDetails]})
                        setSelectedCustomerId(exchangeProducts.customerDetails);
                        dispatch(updateAllReturnProducts(allReturnProducts));
                        dispatch(updateAllReturnProductsDuplicate([]));
                        setReturnModal(true);
                        // console.log(
                        //   exchangeProducts,
                        //   "exchangeProducts.customerDetails"
                        // );
                      }}
                    >
                      <Button
                        // onClick={() => {
                        //   // setSelectedInvoice({
                        //   //   ...exchangeProducts,
                        //   //   customerDetails: [exchangeProducts.customerDetails],
                        //   // });
                        //   // updateAllReturnProducts({...exchangeProducts,customerDetails:[exchangeProducts.customerDetails]})
                        //   setSelectedCustomerId(exchangeProducts.customerDetails);
                        //   dispatch(
                        //     updateAllReturnProducts(allReturnProducts)
                        //   );
                        //   dispatch(updateAllReturnProductsDuplicate([]));
                        //   setReturnModal(true)
                        //   console.log(
                        //     exchangeProducts,
                        //     "exchangeProducts.customerDetails"
                        //   );
                        // }}
                        sx={{
                          backgroundColor: Colors.button,
                          color: Colors.white,
                          marginTop: "30px",
                          fontFamily: "Poppins",
                          fontSize: "12px",
                          padding: "5px",
                          borderRadius: "20px",
                          border: `1px solid ${Colors.button}`,
                          width: "150px",
                          "&:hover": {
                            color: Colors.button, // Set your desired hover color
                          },
                        }}
                      >
                        Back to Return
                      </Button>
                    </Popconfirm>
                  )}

                {showProfit && (
                  <Typography
                    sx={{
                      color: Colors.black,
                      fontSize: "14px",
                      marginTop: 1,
                      fontFamily: "Poppins",
                    }}
                  >
                    {cart &&
                      cart?.length > 0 &&
                      selectedCustomer &&
                      ((
                        totalAmount -
                        discount -
                        costPrice -
                        ( specialDiscount?.selected
                          ? Number(
                              (((totalAmount - discount) *
                                specialDiscount?.value) /
                                100) 
                                // *
                                // (1 + vat.vatRate / 100)
                            )
                          : Number(
                              ((totalAmount - discount) *
                                specialDiscount?.value) /
                                100
                            ))-Math.abs((exchangeProducts?.total||0)-(exchangeProducts?.costPrice||0)-(exchangeProducts?.discount||0)-(exchangeProducts?.SDAmount||0))
                            
                      )).toFixed(2)}
                    .000
                  </Typography>
                )}
                {(userData?.role == "admin" ||
                  userData?.role_access?.some(
                    (e, i) =>
                      e.name.toLowerCase() == "showprofit" && e?.selected
                  )) && (
                  <Button
                    style={{ marginTop: 10 }}
                    onClick={() => setShowProfit(!showProfit)}
                    // onMouseEnter={() => setShowProfit(true)}
                    // onMouseLeave={() => setShowProfit(false)}
                  >
                    <QuestionMarkIcon
                      fontSize="medium"
                      style={{ marginTop: 10 }}
                    />
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* // )} */}

      {/* {openingBalanceModalVisible && userData && userData.role == "employee" && (
        <CustomPOSModal
          open={openingBalanceModalVisible}
          closeModal={closeOpeningModal}
          buttonText={approvedByAdmin ? "Start Shift" : "Approved By Admin"}
          buttonStyle={{
            backgroundColor: approvedByAdmin ? Colors.button : "#5DC002",
          }}
          text={"Your Today Opening Balance Is"}
          specialText="€3000.00"
          heading={`Hello ${userData?.fullName}`}
        />
      )} */}

      {invoiceDetailModal && (
        <InvoiceModal
          open={invoiceDetailModal}
          closeModal={() => setInvoiceDetailModal(false)}
        />
      )}

      {/* {userData.role_access
        ?.find((e) => e.name === "PointOfSale")
        ?.subcategory?.find((e) => e.name === "CreditAccess" && e.selected) ||
      userData.role == "admin" ? (
        <CreditWarningModal
          heading={`Credit Limit Warning`}
          loading={loading}
          text={
            "The customer has been reached out of his credit limit are you sure you want to done this transaction?"
          }
          open={openCreditLimitWarningModal}
          closeModal={() => setOpenCreditLimitWarningModal(false)}
          confirm={(reason, days) =>
            exchangeProducts && Object.keys(exchangeProducts).length > 0
              ? handleConfirmExchangeSale(reason, days)
              : handleConfirmSale(reason, days)
          }
        />
      ) : (
        openCreditLimitWarningModal && (
          <div
            style={{
              position: "absolute",
              top: 0,
              zIndex: 10000,
              width: "70%",
            }}
          >
            <Alert
              message="Credit Limit"
              description="You are not authorized for a credit limit."
              type="error"
              closable
              onClose={() => setOpenCreditLimitWarningModal(false)}
            />
          </div>
        )
      )} */}
      {
        <CreditWarningModal
          heading={`Credit Limit Warning`}
          loading={loading}
          text={
            "The customer has been reached out of his credit limit are you sure you want to done this transaction?"
          }
          open={openCreditLimitWarningModal}
          closeModal={() => setOpenCreditLimitWarningModal(false)}
          confirm={(reason, days) =>
           isEdit?handleConfirmSaleupdate(reason, days): exchangeProducts && Object.keys(exchangeProducts).length > 0
              ? handleConfirmExchangeSale(reason, days)
              : handleConfirmSale(reason, days)
          }
          isAccess={
            userData.role_access
              ?.find((e) => e.name === "PointOfSale")
              ?.subcategory?.find(
                (e) => e.name === "CreditAccess" && e.selected
              ) || userData.role == "admin"
          }
        />
      }
      <CartProductEditModal
        heading={"Edit Product Details"}
        loading={loading}
        text={"Can you confirm that you have received this amount?"}
        open={openEditCartDetailModal}
        closeModal={() => {
          setOpenEditCartDetailModal(false)
          setIsEditOpen(false)
        }}
        product={editCartProductData}
        barcodeRead={barcodeRead}
        setBarcodeRead={setBarcodeRead}
        setHighlightedProduct={setHighlightedProduct}
      />
      <InvoiceSelectorModal
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onSelect={handleSelect}
      />
    </div>
  );
};

export default MainPage;
